/* Your Name From Orbit - storefront customizer */
(function () {
  'use strict';

  var API = 'https://admin.skylitstudio.co.uk/api/name-landsat-data/';
  var ADMIN_BASE = 'https://admin.skylitstudio.co.uk/';
  var MAX_LETTERS = 12;  // per line: one-row names, and each row of the two-row template
  var SAVE_DEBOUNCE = 400;
  var DEFAULT_NAME = 'LANDSAT';

  // Landscape aspect ratios (width / height) per print size.
  var SIZE_AR = {
    'A4': 297 / 210,
    '30 x 40cm': 400 / 300,
    '40 x 50cm': 500 / 400,
    '50 x 70cm': 700 / 500,
    '60 x 80cm': 800 / 600
  };
  // Frame colour -> the .frame-* CSS class suffix on .nl-preview.
  var FRAME_CLASS = {
    'Black': 'frame-black', 'White': 'frame-white',
    'Natural': 'frame-natural', 'Dark Brown': 'frame-dark-brown'
  };

  // Inline SVG icons for the Format picker cards (currentColor-driven).
  var FORMAT_ICON_SVG = ''
    + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">';
  var FORMAT_ICONS = {
    'Framed Print': FORMAT_ICON_SVG +
      '<rect x="3" y="4" width="18" height="16" rx="1.5"/>' +
      '<rect x="6.2" y="7" width="11.6" height="10" rx="0.5"/></svg>',
    'Print Only': FORMAT_ICON_SVG +
      '<path d="M6 3h9l4 4v14H6z"/><path d="M15 3v4h4"/></svg>',
    'Canvas': FORMAT_ICON_SVG +
      '<rect x="3" y="4" width="18" height="16" rx="1"/>' +
      '<line x1="3" y1="4" x2="6.5" y2="7.5"/>' +
      '<line x1="21" y1="4" x2="17.5" y2="7.5"/>' +
      '<line x1="3" y1="20" x2="6.5" y2="16.5"/>' +
      '<line x1="21" y1="20" x2="17.5" y2="16.5"/></svg>'
  };
  var FORMAT_HELP = {
    'Framed Print': 'Ready to hang in a stylish frame. Choose black, white, natural wood or dark brown.',
    'Print Only': 'Premium quality print on 260gsm Photo Lustre paper. Perfect for your own custom framing.',
    'Canvas': 'Gallery-wrapped canvas stretched over a wooden frame. No additional framing needed. Hanging kit included.'
  };

  // Gift add-on variant ids + display prices (pence) — shared with the other
  // customizers (starmap-v2.js GIFT_IDS). Update together if these change.
  var GIFT_IDS = {
    ribbon: '55259137802617',
    giftwrap: '56160831930745',
    bundle: '56160845988217'
  };
  var GIFT_PRICES = { none: 0, ribbon: 249, giftwrap: 369, bundle: 499 };
  var RIBBON_COLORS = {
    'Red': true,
    'Gold': true,
    'Pink': true,
    'Evergreen': true,
    'Navy Blue': true,
    'Baby Blue': true,
    'Pearl White': true,
    'Black': true,
    'Gold Stars': true,
    'Merry Christmas': true
  };

  var el = {
    name: document.getElementById('nl-name'),
    nameSingle: document.getElementById('nl-name-single'),
    nameRows: document.getElementById('nl-name-rows'),
    nameRow1: document.getElementById('nl-name-row1'),
    nameRow2: document.getElementById('nl-name-row2'),
    nameCount: document.getElementById('nl-name-count'),
    nameCountRow1: document.getElementById('nl-name-count-row1'),
    nameCountRow2: document.getElementById('nl-name-count-row2'),
    nameMessage: document.getElementById('nl-name-message'),
    compositions: document.getElementById('nl-compositions'),
    compositionHint: document.getElementById('nl-composition-hint'),
    caption: document.getElementById('nl-caption'),
    captionChips: document.getElementById('nl-caption-chips'),
    annotation: document.getElementById('nl-annotation'),
    annotationFullExample: document.getElementById('nl-annotation-full-example'),
    annotationPlaceExample: document.getElementById('nl-annotation-place-example'),
    giftGrid: document.getElementById('nl-gift-grid'),
    ribbonTooltip: document.getElementById('nl-ribbon-tooltip'),
    ribbonColor: document.getElementById('nl-ribbon-color'),
    ribbonSwatches: document.getElementById('nl-ribbon-swatches'),
    giftNoteSection: document.getElementById('nl-gift-note-section'),
    saveLater: document.getElementById('nl-save-later'),
    share: document.getElementById('nl-share'),
    swatches: document.getElementById('nl-swatches'),
    formats: document.getElementById('nl-formats'),
    frames: document.getElementById('nl-frames'),
    frameSection: document.getElementById('nl-frame-section'),
    sizes: document.getElementById('nl-sizes'),
    strip: document.getElementById('nl-strip'),
    previewEmpty: document.getElementById('nl-preview-empty'),
    loadState: document.getElementById('nl-load-state'),
    loadMessage: document.getElementById('nl-load-message'),
    loadRetry: document.getElementById('nl-load-retry'),
    preview: document.getElementById('nl-preview'),
    previewContent: document.getElementById('nl-preview-content'),
    previewCaption: document.getElementById('nl-preview-caption'),
    previewDescription: document.getElementById('nl-preview-description'),
    deliveryEstimate: document.getElementById('nl-delivery-estimate'),
    status: document.getElementById('nl-status'),
    add: document.getElementById('nl-add'),
    price: document.getElementById('nl-price'),
    priceDisplay: document.getElementById('nl-price-display'),
    mobilePrice: document.getElementById('nl-mobile-price'),
    mobileAdd: document.getElementById('nl-mobile-add'),
    mobilePurchase: document.getElementById('nl-mobile-purchase'),
    mobileError: document.getElementById('nl-mobile-error'),
    previewPane: document.getElementById('nl-preview-pane'),
    previewToggle: document.getElementById('nl-preview-toggle'),
    previewToggleLabel: document.getElementById('nl-preview-toggle-label'),
    varId: document.getElementById('nl-var-id'),
    shuffle: document.getElementById('nl-shuffle'),
    undo: document.getElementById('nl-undo'),
    letterChips: document.getElementById('nl-letter-chips'),
    previewStage: document.getElementById('nl-preview-stage'),
    previewInstruction: document.getElementById('nl-preview-instruction'),
    sampleBadge: document.getElementById('nl-sample-badge'),
    stepNav: document.getElementById('nl-step-nav'),
    designStep: document.getElementById('nl-step-design'),
    finishStep: document.getElementById('nl-step-finish'),
    giftStep: document.getElementById('nl-step-gift'),
    stepBack: document.getElementById('nl-step-back'),
    stepNext: document.getElementById('nl-step-next'),
    stepPosition: document.getElementById('nl-step-position'),
    stepContext: document.getElementById('nl-step-context'),
    designSummary: document.getElementById('nl-design-summary'),
    finishSummary: document.getElementById('nl-finish-summary'),
    giftSummary: document.getElementById('nl-gift-summary')
  };

  var orderId = randomId();
  // Capability token for the server cart-thumbnail render, returned by
  // /api/name-landsat-data/ after a successful save. Mirrors
  // hor-moon-myjs.js's hmCartThumbnailToken. Set inside saveDraft()'s
  // AWAITED chain (not fire-and-forget) — see the comment there.
  var nlCartThumbnailToken = '';
  var index = null;
  var variants = window.nlVariants || [];

  // --- claim mode (post-purchase design attach, design-claim.js) ------------
  // design-claim.js sets window.SkylitClaim.active synchronously the moment
  // ?claim=<token> is in the URL (before it even knows if the token is
  // valid), then resolves asynchronously to `usable: true` (pending claim
  // loaded — dispatches 'skylit:claim-ready' with the paid variant) or
  // leaves `usable: false` with a `message` for every other outcome
  // (loading, already claimed, expired, lookup failed). addToCart() and
  // syncVariant() below key off `active`, NOT `claim`/`usable`, so a
  // customer can never fall through to a normal cart purchase while a
  // claim token is present, in any state — see the CTA/addToCart logic.
  //
  // renderFormats()/renderSizes()/renderFrames() unconditionally reset
  // state.format/size/frame to their first option when bootCustomizer()
  // runs (an async manifest fetch), which can resolve before OR after the
  // claim lookup. If 'skylit:claim-ready' fires first, queue it and apply
  // once boot finishes instead of letting the boot defaults clobber it.
  var pendingClaimVariant = null;
  function applyClaimVariant(claim) {
    if (claim.type) { selectFormat(claim.type); }
    if (claim.size) { selectSize(claim.size); }
    if (claim.frame && claim.frame !== 'No Frame') { selectFrame(claim.frame); }
    applyClaimLock();
  }
  document.addEventListener('skylit:claim-ready', function (e) {
    var claim = e.detail || {};
    if (customizerBooted) { applyClaimVariant(claim); }
    else { pendingClaimVariant = claim; }
  });

  // Disables the actual interactive descendants of the size/format/frame
  // pickers (not just their container) so both mouse AND keyboard
  // (bindRadioKeyboard reads `button.disabled` live on every keydown, so
  // this alone is enough — no rebinding needed) are blocked. Idempotent;
  // safe to call repeatedly. Runs purely off `active` (token present) so it
  // locks down even before the claim lookup resolves, and even if it never
  // resolves to a usable claim.
  function applyClaimLock() {
    if (!(window.SkylitClaim && window.SkylitClaim.active)) { return; }
    [el.formats, el.frames, el.sizes].forEach(function (container) {
      if (!container) { return; }
      Array.prototype.forEach.call(container.querySelectorAll('button'), function (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
        btn.tabIndex = -1;
      });
    });
  }

  // Letter images are served from R2 via our own admin worker route, NOT from
  // Shopify's theme CDN. Shopify's edge does Accept-aware image transformation
  // that historically cached image/jxl responses (broken in Chrome/Firefox/Edge);
  // serving via /api/yor-letter/<key>.jpg pins content-type to image/jpeg with
  // immutable cache headers, eliminating that failure mode. See
  // [[reference_shopify_cdn_jxl_poisoning]].
  var LETTER_IMG_BASE = 'https://admin.skylitstudio.co.uk/api/yor-letter/';

  // Attach an <img> with a graceful per-image fallback. Kept as a safety net
  // for transient network failures even though R2 serving makes systematic
  // poisoning impossible. If the chosen variant fails to load, shuffle through
  // the remaining variants of the same letter in random order until one loads,
  // mutating state.letterKeys so the rendered choice matches what ends up
  // persisted to the order. If every alternative fails, keep the tile's
  // footprint stable and turn it into an explicit retry control.
  function attachWithFallback(img, variant, originalKey, slotIdx) {
    var letter = originalKey.split('_')[0].toUpperCase();
    var tile = img.parentNode;
    var alternates = ((index && index[letter]) || [])
      .filter(function (o) { return o.key !== originalKey; })
      .slice()
      .sort(function () { return Math.random() - 0.5; });

    function srcFor(v) {
      return LETTER_IMG_BASE + v.preview_file;
    }
    function handleLoad() {
      img.onload = null;
      if (tile) {
        tile.classList.remove('nl-tile--loading', 'nl-tile--error');
        tile.removeAttribute('data-load-error');
        updateTileButtonLabel(tile, slotIdx);
      }
    }
    function handleError() {
      if (alternates.length === 0) {
        img.onerror = null;
        console.warn('[nl] all variants exhausted for letter', letter, '— offering retry');
        if (tile) {
          tile.classList.remove('nl-tile--loading');
          tile.classList.add('nl-tile--error');
          tile.setAttribute('data-load-error', 'true');
          tile.removeAttribute('aria-disabled');
          tile.setAttribute('aria-label', 'Satellite image failed to load for letter ' + letter +
            ', position ' + (slotIdx + 1) + '. Select to retry.');
        }
        announce('A satellite image could not load. Select its tile to try again.');
        track('preview_image_failed', { yor_letter: letter, yor_position: slotIdx + 1 });
        return;
      }
      var next = alternates.shift();
      console.warn('[nl] image load failed for', originalKey, '— trying', next.key);
      if (slotIdx >= 0 && slotIdx < state.letterKeys.length) {
        state.letterKeys[slotIdx] = next.key;
        updateAnnotationExamples(state.letterKeys);
      }
      img.dataset.variantKey = next.key;
      if (tile) {
        tile.dataset.variantKey = next.key;
        paintTileAnnotation(tile, next, isLight(state.backgroundColor) ? '#141418' : '#ebebee');
      }
      img.src = srcFor(next);
    }
    // Anonymous-CORS required so the customer-side cart thumbnail canvas can
    // drawImage() these without tainting. The admin worker route returns
    // Access-Control-Allow-Origin: https://skylitstudio.co.uk — which does
    // NOT match the CF Browser-Rendering host's origin (agent.skylitstudio.co.uk).
    // Skip it in headless mode: the host only ever screenshots the painted
    // page (no canvas pixel read-back), and a CORS-mode request whose
    // response lacks a matching ACAO header fails to load at all, whereas a
    // plain same-site request paints fine (the route's referrer gate accepts
    // Sec-Fetch-Site: same-site, which this request sends regardless).
    if (!window.__NL_HEADLESS) { img.crossOrigin = 'anonymous'; }
    img.onload = handleLoad;
    img.onerror = handleError;
    if (tile) {
      tile.classList.remove('nl-tile--error');
      tile.classList.add('nl-tile--loading');
      tile.removeAttribute('data-load-error');
    }
    img.src = srcFor(variant);
  }
  var state = {
    /* showCoordinates default flipped to true on 2026-05-27 — the location
       + lat/lon annotation strip is the YOR print's hero detail, so it
       should be on by default rather than hidden behind a toggle. The
       <input id="nl-coords"> is rendered with `checked` to match. Edit-
       mode hydration in loadOrder() will still override this from the
       customer's saved value. */
    name: '', letterKeys: [], caption: '', showCoordinates: true,
    /* Layout v2 adds semantic word spaces and an optional two-row template.
       letterKeys remains a flat, letters-only array for backward compatibility;
       lineBreakAfter records how many letter tiles belong on the first row. */
    composition: 'single-row', lineBreakAfter: null,
    /* annotationMode supersedes the old boolean: 'full' (place + lat/lon),
       'place' (place name only) or 'none'. showCoordinates stays mirrored
       (mode !== 'none') for legacy payload/back-compat consumers. */
    annotationMode: 'full',
    backgroundColor: '#f5f0e6',
    format: '', size: '', frame: '', variantId: '',
    gift: 'none', ribbonColor: 'Red', giftPaper: 'dots'
  };
  var saveTimer = null;
  var isHydrating = false;
  var nlAutosavePrimed = false;   // withheld while a resume modal is pending
  var giftBeforePrint = null;     // stash when Print Only hides wrap/bundle
  var letterHistory = [];
  var hasTrackedNameEntry = false;
  var lastInvalidVariantKey = '';
  var activeStep = 1;
  var _nlStepScrollRequest = 0;

  // --- edit-mode state (ported from custom-print.js / starmap-v2.js) --------
  var isEditMode = false;
  var cartOrderIdPresent = [];   // _OrderID strings from current cart (print lines only)
  var cartOrderIdKeys = [];      // matching cart item.key values

  function randomId() {
    return Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
  }

  function announce(message) {
    if (!el.status) { return; }
    // Clear first so repeating a useful status is announced again.
    el.status.textContent = '';
    window.setTimeout(function () { el.status.textContent = message || ''; }, 20);
  }

  function setChecked(container, selector, isSelected) {
    if (!container) { return; }
    Array.prototype.forEach.call(container.querySelectorAll(selector), function (button) {
      button.setAttribute('aria-checked', isSelected(button) ? 'true' : 'false');
    });
  }

  // Button-based radio groups keep the custom card design while matching
  // native radio keyboard behaviour (arrows, Home and End).
  function bindRadioKeyboard(container, selector) {
    if (!container) { return; }
    function syncTabStops() {
      var buttons = Array.prototype.slice.call(container.querySelectorAll(selector));
      var checked = buttons.filter(function (button) {
        return button.getAttribute('aria-checked') === 'true' && !button.disabled && !button.hidden;
      })[0] || buttons.filter(function (button) { return !button.disabled && !button.hidden; })[0];
      buttons.forEach(function (button) { button.tabIndex = button === checked ? 0 : -1; });
    }
    syncTabStops();
    container.addEventListener('click', function () { window.setTimeout(syncTabStops, 0); });
    container.addEventListener('keydown', function (event) {
      if (['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'].indexOf(event.key) === -1) { return; }
      var buttons = Array.prototype.slice.call(container.querySelectorAll(selector)).filter(function (button) {
        return !button.disabled && !button.hidden;
      });
      if (!buttons.length) { return; }
      var current = buttons.indexOf(document.activeElement);
      var next = current < 0 ? 0 : current;
      if (event.key === 'Home') { next = 0; }
      else if (event.key === 'End') { next = buttons.length - 1; }
      else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') { next = (next + 1) % buttons.length; }
      else { next = (next - 1 + buttons.length) % buttons.length; }
      event.preventDefault();
      buttons[next].focus();
      buttons[next].click();
    });
  }

  var EUROPE_COUNTRIES = {
    AT: true, BE: true, BG: true, HR: true, CY: true, CZ: true, DE: true, DK: true,
    EE: true, ES: true, FI: true, FR: true, GR: true, HU: true, IE: true, IS: true,
    IT: true, LI: true, LT: true, LU: true, LV: true, MT: true, NL: true, NO: true,
    PL: true, PT: true, RO: true, SE: true, SI: true, SK: true, CH: true
  };
  function ukClock() {
    var now = new Date(), values = {};
    try {
      new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London', year: 'numeric', month: 'numeric', day: 'numeric',
        hour: 'numeric', hourCycle: 'h23'
      }).formatToParts(now).forEach(function (part) { values[part.type] = Number(part.value); });
      return { date: new Date(Date.UTC(values.year, values.month - 1, values.day, 12)), hour: values.hour };
    } catch (e) {
      return { date: new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 12)), hour: now.getUTCHours() };
    }
  }
  function isBusinessDay(date) {
    var day = date.getUTCDay();
    return day !== 0 && day !== 6;
  }
  function addBusinessDays(date, count) {
    var out = new Date(date.getTime()), added = 0;
    while (added < count) {
      out.setUTCDate(out.getUTCDate() + 1);
      if (isBusinessDay(out)) { added++; }
    }
    return out;
  }
  function formatDeliveryDate(date) {
    try {
      return new Intl.DateTimeFormat(navigator.language || 'en-GB', {
        weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC'
      }).format(date);
    } catch (e) {
      return date.toDateString().replace(/ \d{4}$/, '');
    }
  }
  function renderDeliveryEstimate() {
    if (!el.deliveryEstimate) { return; }
    var country = (el.deliveryEstimate.dataset.country || 'GB').toUpperCase();
    var clock = ukClock();
    var dispatch = clock.date;
    if (!isBusinessDay(dispatch) || clock.hour >= 15) { dispatch = addBusinessDays(dispatch, 1); }
    // Canvas production needs one additional working day before dispatch.
    if (state.format === 'Canvas') { dispatch = addBusinessDays(dispatch, 1); }
    var transit = country === 'GB' ? [2, 4] : (EUROPE_COUNTRIES[country] ? [4, 8] : [7, 12]);
    var earliest = addBusinessDays(dispatch, transit[0]);
    var latest = addBusinessDays(dispatch, transit[1]);
    el.deliveryEstimate.textContent = '✓ Estimated dispatch ' + formatDeliveryDate(dispatch) +
      ' · delivery ' + formatDeliveryDate(earliest) + '–' + formatDeliveryDate(latest);
    el.deliveryEstimate.title = 'Estimated working-day dates; bank holidays and customs may affect delivery.';
  }

  // Storefront-owned analytics contract. GTM can consume the dataLayer event,
  // while non-GTM integrations can subscribe to the yor:analytics DOM event.
  // This deliberately does not depend on the admin order-event endpoint, which
  // may not know about a draft order yet.
  function track(eventName, detail) {
    var payload = Object.assign({
      event: 'yor_customiser',
      yor_event: eventName,
      yor_order_id: orderId,
      yor_format: state.format || '',
      yor_size: state.size || '',
      yor_frame: state.frame || '',
      yor_name_length: lettersOnly(state.name).length,
      yor_composition: state.composition,
      yor_device: window.innerWidth <= 880 ? 'mobile' : 'desktop'
    }, detail || {});
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (e) {}
    try {
      window.dispatchEvent(new CustomEvent('yor:analytics', { detail: payload }));
    } catch (e) {}
  }

  function setAddButtonState(label, disabled) {
    [el.add, el.mobileAdd].forEach(function (button) {
      if (!button) { return; }
      button.disabled = !!disabled;
      // Mirror aria-disabled onto .disabled here. design-claim.js's
      // setCtaLabel() sets both together on [data-claim-cta] while it owns
      // the button (loading/blocked claim states), but only ever sets them
      // TRUE — it has no way to know when the section considers the button
      // usable again. This is the only re-enable path for #nl-add /
      // #nl-mobile-add, so if it doesn't clear aria-disabled here, nothing
      // ever does: disabled becomes false but the button still announces
      // as unavailable to assistive tech (and Playwright refuses to click
      // it). Keep this pair moving together.
      button.setAttribute('aria-disabled', String(!!disabled));
      button.textContent = label;
    });
  }

  function updateSectionSummaries() {
    if (el.designSummary) {
      var bgButton = el.swatches && el.swatches.querySelector('.nl-swatch--active .nl-swatch__label');
      var bgLabel = bgButton ? bgButton.textContent.trim() : '';
      var layoutLabel = effectiveComposition() === 'two-row' ? 'Two rows' : 'One row';
      el.designSummary.textContent = state.name
        ? normalizedName(state.name) + ' · ' + layoutLabel + (bgLabel ? ' · ' + bgLabel : '')
        : 'Enter a name';
    }
    if (el.finishSummary) {
      var bits = [state.format, isFramed() ? state.frame : '', state.size].filter(Boolean);
      el.finishSummary.textContent = bits.length ? bits.join(' · ') : 'Format, frame and size';
    }
    if (el.giftSummary) {
      var giftButton = el.giftGrid && el.giftGrid.querySelector('[data-nl-gift="' + state.gift + '"] .nl-gift-tile__label');
      el.giftSummary.textContent = state.gift === 'none'
        ? 'Optional'
        : (giftButton ? giftButton.textContent.replace(/\s*\(.+\)\s*$/, '') : state.gift);
    }
    if (el.stepContext) {
      var summaries = [el.designSummary, el.finishSummary, el.giftSummary];
      var summary = summaries[activeStep - 1];
      el.stepContext.textContent = summary ? summary.textContent : '';
    }
  }
  // Transliterate accented/special letters instead of silently dropping them —
  // stripping made CHLOÉ print as CHLO and ZOË as ZO, which for a NAME product
  // is the worst possible silent failure. NFD decomposition peels combining
  // accents (É → E + ́); the map covers the non-decomposable letters. Note
  // 'ß'.toUpperCase() is already 'SS' in JS.
  var TRANSLIT = { 'Æ': 'AE', 'Ø': 'O', 'Œ': 'OE', 'Þ': 'TH', 'Ð': 'D', 'Ł': 'L', 'Đ': 'D' };
  function lettersOnly(value) {
    return String(value || '').replace(/[^A-Z]/g, '');
  }
  function normalizedName(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }
  function nameWords(value) {
    var clean = normalizedName(value);
    return clean ? clean.split(' ') : [];
  }
  function suggestedLineBreak(value) {
    var words = nameWords(value);
    if (words.length < 2) { return null; }
    var total = words.join('').length;
    var best = words[0].length;
    var used = 0;
    var bestDistance = Infinity;
    for (var i = 0; i < words.length - 1; i++) {
      used += words[i].length;
      var distance = Math.abs(total - used * 2);
      if (distance < bestDistance) {
        bestDistance = distance;
        best = used;
      }
    }
    return best;
  }
  function isValidLineBreak(value, breakAfter) {
    var words = nameWords(value);
    if (words.length < 2 || !breakAfter) { return false; }
    var used = 0;
    for (var i = 0; i < words.length - 1; i++) {
      used += words[i].length;
      if (used === Number(breakAfter)) { return true; }
    }
    return false;
  }
  // The composition that is actually in effect: 'two-row' only once the name
  // carries a valid break. With the row inputs a customer can pick Two Rows
  // before typing anything, so the persisted/rendered composition must not
  // claim two rows while row 2 is still empty.
  function effectiveComposition() {
    return state.composition === 'two-row' && isValidLineBreak(state.name, state.lineBreakAfter)
      ? 'two-row'
      : 'single-row';
  }
  function effectiveLineBreak() {
    return effectiveComposition() === 'two-row' ? Number(state.lineBreakAfter) : null;
  }
  function splitRows(value, breakAfter) {
    var clean = normalizedName(value);
    if (!clean || !isValidLineBreak(clean, breakAfter)) { return [clean, '']; }
    var words = nameWords(clean), used = 0, top = [], bottom = [];
    words.forEach(function (word) {
      if (used < Number(breakAfter)) { top.push(word); } else { bottom.push(word); }
      used += word.length;
    });
    return [top.join(' '), bottom.join(' ')];
  }
  function layoutRows(value) {
    var clean = normalizedName(value);
    if (!clean || effectiveComposition() !== 'two-row') { return [clean]; }
    var breakAfter = Number(state.lineBreakAfter);
    var words = nameWords(clean), used = 0, top = [], bottom = [];
    words.forEach(function (word) {
      if (used < breakAfter) { top.push(word); } else { bottom.push(word); }
      used += word.length;
    });
    return bottom.length ? [top.join(' '), bottom.join(' ')] : [clean];
  }
  function sanitizeNameResult(raw) {
    var source = String(raw || '');
    var maxLetters = MAX_LETTERS;
    var s = source.toUpperCase();
    var hadCombiningAccent = false;
    try {
      var decomposed = s.normalize('NFD');
      hadCombiningAccent = /[\u0300-\u036f]/.test(decomposed);
      s = decomposed.replace(/[\u0300-\u036f]/g, '');
    } catch (e) {}
    var hadMappedLetter = /[ÆØŒÞÐŁĐß]/i.test(source);
    s = s.replace(/[ÆØŒÞÐŁĐ]/g, function (c) { return TRANSLIT[c] || ''; });
    var unsupported = s.replace(/[A-Z\s]/g, '');
    s = s.replace(/[^A-Z\s]/g, '').replace(/\s+/g, ' ').replace(/^ /, '');
    var clean = '', count = 0;
    for (var i = 0; i < s.length; i++) {
      if (s[i] === ' ') {
        if (clean && clean[clean.length - 1] !== ' ' && count < maxLetters) { clean += ' '; }
      } else if (count < maxLetters) {
        clean += s[i];
        count++;
      }
    }
    if (count >= maxLetters) { clean = clean.replace(/\s+$/, ''); }
    var letters = lettersOnly(s);
    return {
      clean: clean,
      transliterated: hadCombiningAccent || hadMappedLetter,
      removed: unsupported.length > 0,
      truncated: letters.length > maxLetters,
      source: source
    };
  }
  function sanitizeName(raw) {
    return sanitizeNameResult(raw).clean;
  }
  // Each entry field carries its own n/12 counter inside the box.
  function paintCounter(node, value, atLimit) {
    if (!node) { return; }
    node.textContent = lettersOnly(value).length + '/' + MAX_LETTERS;
    node.classList.toggle('nl-input-count--full', atLimit);
  }
  function updateNameCounter() {
    var rows = splitRows(state.name, state.lineBreakAfter);
    paintCounter(el.nameCount, state.name, lettersOnly(state.name).length >= MAX_LETTERS);
    paintCounter(el.nameCountRow1, rows[0], lettersOnly(rows[0]).length >= MAX_LETTERS);
    paintCounter(el.nameCountRow2, rows[1], lettersOnly(rows[1]).length >= MAX_LETTERS);
  }
  function showNameFeedback(result) {
    updateNameCounter();
    if (!el.nameMessage) { return; }
    var messages = [];
    if (result.transliterated && result.clean) {
      messages.push('Adjusted to “' + result.clean + '” because the artwork uses letters A–Z.');
    }
    if (result.removed) {
      messages.push(result.clean
        ? 'Unsupported characters were removed.'
        : 'That character cannot be used; enter letters A–Z.');
    }
    if (result.truncated) {
      messages.push(state.composition === 'two-row'
        ? 'Each row can contain up to ' + MAX_LETTERS + ' letters.'
        : 'Names can contain up to ' + MAX_LETTERS + ' letters in total.');
    }
    el.nameMessage.textContent = messages.join(' ');
    el.nameMessage.hidden = messages.length === 0;
  }
  // Mirror state.name into whichever entry fields the template shows: the
  // single Name input, or the Row 1 / Row 2 pair. Values are only written
  // when they differ so a customer's caret is left alone mid-typing.
  function setInputValue(input, value) {
    if (input && input.value !== value) { input.value = value; }
  }
  function syncNameInputs() {
    var twoRow = state.composition === 'two-row';
    if (el.nameSingle) { el.nameSingle.hidden = twoRow; }
    if (el.nameRows) { el.nameRows.hidden = !twoRow; }
    if (twoRow) {
      var rows = splitRows(state.name, state.lineBreakAfter);
      setInputValue(el.nameRow1, rows[0]);
      setInputValue(el.nameRow2, rows[1]);
    } else {
      setInputValue(el.name, normalizedName(state.name));
    }
  }
  function activeNameInput() {
    if (state.composition === 'two-row' && el.nameRow1) {
      return normalizedName(el.nameRow1.value) && el.nameRow2 && !normalizedName(el.nameRow2.value)
        ? el.nameRow2
        : el.nameRow1;
    }
    return el.name;
  }
  function focusNameInput() {
    var input = activeNameInput();
    if (input) { input.focus(); }
  }
  function updateCompositionControls() {
    if (!el.compositions) { return; }
    // Two rows hold up to MAX_LETTERS each, so a long two-row name cannot be
    // folded back into one row without losing letters: lock One Row instead.
    var tooLongForOneRow = state.composition === 'two-row' && lettersOnly(state.name).length > MAX_LETTERS;
    Array.prototype.forEach.call(el.compositions.querySelectorAll('[data-composition]'), function (btn) {
      var value = btn.dataset.composition;
      var active = value === state.composition;
      btn.classList.toggle('nl-composition--active', active);
      btn.setAttribute('aria-checked', active ? 'true' : 'false');
      if (value === 'single-row') {
        btn.disabled = tooLongForOneRow;
        btn.classList.toggle('nl-composition--disabled', tooLongForOneRow);
      }
    });
    if (el.compositionHint) {
      var hint = 'Words sit side by side on one line.';
      if (state.composition === 'two-row') {
        hint = effectiveComposition() === 'two-row'
          ? 'Row 1 sits above Row 2 in the artwork.'
          : 'Add a word to each row to complete the two-row layout.';
        hint += ' Up to ' + MAX_LETTERS + ' letters per row.';
        if (tooLongForOneRow) { hint += ' One row holds ' + MAX_LETTERS + ' letters in total.'; }
      }
      el.compositionHint.textContent = hint;
    }
    syncNameInputs();
  }
  function setComposition(value) {
    if (value !== 'single-row' && value !== 'two-row') { return; }
    if (value === 'single-row' && lettersOnly(state.name).length > MAX_LETTERS) { return; }
    var changed = value !== state.composition;
    state.composition = value;
    // One row -> two rows: seed the rows with the existing balanced split (a
    // single word lands in Row 1 with Row 2 left for the customer to fill).
    state.lineBreakAfter = value === 'two-row' ? suggestedLineBreak(state.name) : null;
    updateCompositionControls();
    // Validation feedback was about the previous entry fields; the counter
    // is re-derived for the new template.
    if (el.nameMessage) { el.nameMessage.hidden = true; el.nameMessage.textContent = ''; }
    updateNameCounter();
    renderPreview();
    updateSectionSummaries();
    scheduleSave();
    if (!isHydrating) {
      track('option_changed', { yor_option: 'composition', yor_value: value });
      if (changed && value === 'two-row' && el.nameRow2 && !normalizedName(el.nameRow2.value)) {
        el.nameRow2.focus();
      }
    }
  }
  function money(cents) { var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP'; var sym = { GBP: '\u00a3', EUR: '\u20ac', USD: '$', AUD: 'A$', CAD: 'CA$' }[cur] || (cur + ' '); return sym + (cents / 100).toFixed(2); }
  function uniq(list) {
    var seen = {}, out = [];
    list.forEach(function (v) { if (!seen[v]) { seen[v] = 1; out.push(v); } });
    return out;
  }
  // Saved drafts have historically persisted the size in several formats
  // ("40 x 50", "60x80") that don't byte-match the current Shopify variant
  // labels ("40 x 50cm"). normalizeSize collapses those differences so a saved
  // size can be resolved back to the real, selectable variant label on
  // rehydrate. Also future-proofs against Shopify relabelling the size option.
  function normalizeSize(s) {
    return String(s || '').toLowerCase().replace(/cm/g, '').replace(/×/g, 'x').replace(/\s+/g, '');
  }
  // Map a persisted size to the matching current variant size label, or null.
  function resolveSize(raw) {
    var want = normalizeSize(raw), match = null;
    variants.some(function (v) {
      if (normalizeSize(v.size) === want) { match = v.size; return true; }
      return false;
    });
    return match;
  }
  function escapeHtml(s) {
    return (s || '').replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  // Split "LAT N  LON W" into a latitude line and a longitude line so each
  // sits on its own row under the tile.
  function coordLines(coords) {
    var c = (coords || '').trim();
    var m = c.match(/^(.+?[NS])\s+(.+[EW])$/);
    if (m) {
      return '<div class="nl-tile-coord">' + escapeHtml(m[1]) +
        '</div><div class="nl-tile-coord">' + escapeHtml(m[2]) + '</div>';
    }
    return c ? '<div class="nl-tile-coord">' + escapeHtml(c) + '</div>' : '';
  }
  // The name actually used for rendering. Falls back to DEFAULT_NAME when the
  // customer has not yet typed anything so the preview always shows something.
  function effectiveName() {
    return normalizedName(state.name) || DEFAULT_NAME;
  }
  function effectiveLetters() {
    return lettersOnly(effectiveName());
  }
  function isLight(hex) {
    var s = hex.replace('#', '');
    var r = parseInt(s.substr(0, 2), 16), g = parseInt(s.substr(2, 2), 16), b = parseInt(s.substr(4, 2), 16);
    return (0.299 * r + 0.587 * g + 0.114 * b) > 140;
  }
  function isFramed() { return state.format === 'Framed Print'; }

  // --- edit-mode badge (ported from custom-print.js:showEditModeIndicator) ---
  // Injects a small "EDITING" pill next to the page heading so the customer
  // knows they are modifying an existing order and not creating a new one.
  function showEditModeIndicator() {
    // The h1 is visually hidden (above-the-fold change), so the badge goes at
    // the top of the settings column instead.
    var settings = document.querySelector('.nl-settings');
    if (settings && !document.querySelector('.nl-edit-mode-badge')) {
      var badge = document.createElement('span');
      badge.className = 'nl-edit-mode-badge';
      badge.textContent = 'EDITING';
      settings.insertBefore(badge, settings.firstChild);
    }
  }

  // --- order-event logging (fire-and-forget) --------------------------------
  // The order-event route currently only searches star_maps / moon_maps /
  // horizontal_moon_maps / location_maps / custom_prints — name_landsat_maps
  // is not yet in the TABLES list, so the POST returns 404 for these orders.
  // The calls below are wrapped in .catch(noop) so the 404 is silent and does
  // not block any user-facing flow. Add name_landsat to the backend TABLES to
  // fully activate this tracking (see deferred items in the PR report).
  function logOrderEvent(eventName) {
    try {
      // keepalive: edit_personalisations_confirmed fires just before the
      // redirect to /cart, which otherwise cancels it in flight.
      fetch(ADMIN_BASE + 'api/order-event', {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          order_id: orderId,
          event: eventName,
          detail: window.location.href.slice(0, 200)
        })
      }).catch(function () {});
    } catch (e) {}
  }

  // --- cart state loader (ported from custom-print.js:loadCartItems) --------
  // Fetch the live Shopify cart and populate cartOrderIdPresent / cartOrderIdKeys
  // so addToCart can decide whether to remove-and-re-add (edit) or just add.
  function loadCartItems() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartOrderIdPresent = [];
        cartOrderIdKeys = [];
        (cart.items || []).forEach(function (item) {
          if (!item.properties) { return; }
          var itemOrderId = item.properties._OrderID || item.properties.OrderID;
          if (!itemOrderId) { return; }
          cartOrderIdPresent.push(itemOrderId);
          cartOrderIdKeys.push(item.key);
        });
        console.log('[Name Landsat] cart order IDs loaded:', cartOrderIdPresent);
      })
      .catch(function (err) {
        console.warn('[Name Landsat] loadCartItems failed:', err && err.message);
      });
  }

  // Add-to-cart navigates to /cart, so pressing Back restores this page from
  // the back-forward cache with the PRE-ADD cart snapshot still in memory:
  // isEditMode stays false, the CTA still reads "Add to basket", and — until
  // the guard in scheduleSave() — autosave stayed live and silently overwrote
  // the design the customer had already confirmed. Re-read the live cart on
  // restore so edit mode is honest. Mirrors the pageshow handlers in
  // locationmap.js and hor-moon-myjs.js; YOR had none.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) { return; }
    loadCartItems().then(function () {
      if (!orderId) { return; }
      isEditMode = cartOrderIdPresent.indexOf(orderId) !== -1;
      if (isEditMode) { showEditModeIndicator(); }
      syncVariant();
      console.log('[Name Landsat] bfcache restore — cart re-read, editMode=' + isEditMode);
    });
  });

  // --- syncVariant (with edit-mode CTA label) --------------------------------
  // Mirrors custom-print.js:updateAddToCartButton — shows context-aware label.
  function syncVariant() {
    // Any state change clears a stale add-to-cart error from a previous attempt.
    clearAddError();
    // Wrap/bundle are priced by the size being wrapped, but the gift tiles
    // render from the gift product's FIRST variant (the smallest tier), so
    // re-stamp them for the size selected now.
    try { if (window.SkylitGifts) window.SkylitGifts.refreshLabels(state.size); } catch (e) {}
    var v = resolveVariant();
    var customerHasTyped = normalizedName(state.name).length > 0;
    // Claim mode: `active` is true the instant ?claim= is in the URL, before
    // the lookup even resolves. `usable` only goes true for a confirmed
    // pending claim. Any active-but-not-usable state (still loading,
    // already claimed, expired, or the lookup failed) must force the CTA
    // disabled with the driver's message, overriding every branch below —
    // this is what stops a customer reopening an already-claimed link (or
    // hitting one transient fetch error) from ever seeing an enabled
    // "Add to basket" that would charge them again.
    var claimActive = !!(window.SkylitClaim && window.SkylitClaim.active);
    var claimUsable = claimActive && window.SkylitClaim.usable && window.SkylitClaim.claim;
    var claimBlockedLabel = (window.SkylitClaim && window.SkylitClaim.message) || 'Unavailable';
    if (v && v.available && !v.ukOnly) {
      state.variantId = String(v.id);
      el.varId.value = v.id;
      el.price.textContent = money(v.price);
      // Always-visible TOTAL (independent of the name gate) so the price shows
      // on the landing view — needed for the Google auto-discount display and
      // Merchant Center's "price shown on PDP" check. Includes the gift add-on.
      var nlGiftPence = GIFT_PRICES[state.gift] || 0;
      try {
        if (state.gift && state.gift !== 'none' && window.SkylitGifts) {
          nlGiftPence = window.SkylitGifts.priceFor(state.gift, state.size) || nlGiftPence;
        }
      } catch (e) {}
      if (el.priceDisplay) el.priceDisplay.textContent = money(v.price + nlGiftPence);
      if (el.mobilePrice) el.mobilePrice.textContent = money(v.price + nlGiftPence);
      // Only enable add-to-basket when customer has typed their own name.
      // Price lives in the TOTAL row above (house pattern) — plain CTA copy.
      if (claimActive && !claimUsable) {
        setAddButtonState(claimBlockedLabel, true);
      } else if (!customerHasTyped) {
        setAddButtonState('Enter a name to continue', true);
      } else if (claimUsable) {
        setAddButtonState('Confirm my design', false);
      } else if (isEditMode) {
        setAddButtonState('Confirm edits', false);
      } else {
        setAddButtonState(window.SkylitGalleryWall && window.SkylitGalleryWall.active() ? 'Add to gallery wall' : 'Add to basket', false);
      }
      lastInvalidVariantKey = '';
    } else {
      // Either no variant matches the current combo, or the variant exists
      // but is sold out. Disable the button and report the actual reason in
      // its label rather than greying out the picker.
      state.variantId = '';
      el.varId.value = '';
      el.price.textContent = '';
      if (el.priceDisplay) el.priceDisplay.textContent = '';
      if (el.mobilePrice) el.mobilePrice.textContent = '';
      var unavailableLabel = '';
      if (claimActive && !claimUsable) {
        unavailableLabel = claimBlockedLabel;
      } else if (!customerHasTyped) {
        unavailableLabel = 'Enter a name to continue';
      } else if (v && v.ukOnly) {
        unavailableLabel = 'UK delivery only · try a smaller size';
      } else {
        // Distinguish between "combination doesn't exist" and "out of stock"
        // for slightly clearer copy.
        var anyMatch = variants.some(function (vx) {
          var wantFrame = isFramed() ? state.frame : 'No Frame';
          return vx.format === state.format && vx.size === state.size && vx.frame === wantFrame;
        });
        unavailableLabel = anyMatch
          ? 'Sold out · try another size or frame'
          : 'Not available · try another size or frame';
      }
      setAddButtonState(unavailableLabel, true);
      var invalidKey = [state.format, state.size, state.frame, unavailableLabel].join('|');
      if (customerHasTyped && invalidKey !== lastInvalidVariantKey) {
        lastInvalidVariantKey = invalidKey;
        track('invalid_variant', { yor_reason: unavailableLabel });
      }
    }
    updateSectionSummaries();
    refreshOptionMeta();
    renderDeliveryEstimate();
  }

  // --- manifest -----------------------------------------------------------
  // Bump MANIFEST_VERSION every time nl-manifest.json changes. Shopify's CDN
  // keys cache on `?v=...` query strings specifically (other query names are
  // ignored, so e.g. `?bust=...` would serve stale content). Without this,
  // new letter entries take days to reach customers as the Shopify edge
  // cache holds the old manifest body.
  var MANIFEST_VERSION = '77';
  function loadManifest() {
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timeout = window.setTimeout(function () {
      if (controller) { controller.abort(); }
    }, 15000);
    return fetch(window.nlAssetBase + 'nl-manifest.json?v=' + MANIFEST_VERSION,
      controller ? { signal: controller.signal } : {})
      .then(function (r) {
        if (!r.ok) { throw new Error('Satellite library returned ' + r.status); }
        return r.json();
      })
      .then(function (m) {
        if (!m || !m.letters || !Object.keys(m.letters).length) {
          throw new Error('Satellite library is empty');
        }
        index = m.letters;
      })
      .finally(function () { window.clearTimeout(timeout); });
  }
  function setManifestLoadState(mode, message) {
    var loading = mode === 'loading';
    var failed = mode === 'error';
    if (el.preview) { el.preview.setAttribute('aria-busy', loading ? 'true' : 'false'); }
    if (!el.loadState) { return; }
    el.loadState.hidden = mode === 'ready';
    el.loadState.classList.toggle('nl-load-state--error', failed);
    if (el.loadMessage) {
      el.loadMessage.textContent = message || (loading
        ? 'Loading satellite imagery…'
        : 'We couldn’t load the satellite imagery library.');
    }
    if (el.loadRetry) {
      el.loadRetry.hidden = !failed;
      el.loadRetry.disabled = loading;
    }
  }
  function chooseLetterKeys(name) {
    if (!index) { return []; }
    name = lettersOnly(name);
    var counts = {}, keys = [];
    for (var i = 0; i < name.length; i++) {
      var ch = name[i], list = index[ch] || [];
      if (!list.length) { return []; }
      var n = counts[ch] || 0; counts[ch] = n + 1;
      keys.push(list[n % list.length].key);
    }
    return keys;
  }
  // Random pick: each letter gets a uniformly random variant. Tries a few
  // times to avoid returning the identical set so each Shuffle click is
  // visibly different.
  function randomKeys(name, previous) {
    if (!index || !name) { return []; }
    name = lettersOnly(name);
    var keys = [];
    for (var attempt = 0; attempt < 4; attempt++) {
      keys = [];
      for (var i = 0; i < name.length; i++) {
        var list = index[name[i]] || [];
        if (!list.length) { return []; }
        keys.push(list[Math.floor(Math.random() * list.length)].key);
      }
      var same = previous && keys.length === previous.length &&
        keys.every(function (k, j) { return k === previous[j]; });
      if (!same) { break; }
    }
    return keys;
  }
  // Shuffle is meaningful only if at least one letter in the name has more
  // than one available variant (otherwise the result is identical).
  function canShuffle() {
    if (!state.letterKeys.length || !index) { return false; }
    var name = effectiveLetters();
    for (var i = 0; i < name.length; i++) {
      var list = index[name[i]] || [];
      if (list.length > 1) { return true; }
    }
    return false;
  }
  function canShuffleLetter(i) {
    if (!index) { return false; }
    var name = effectiveLetters();
    var ch = name[i];
    if (!ch) { return false; }
    return (index[ch] || []).length > 1;
  }
  function shuffleVariants() {
    if (!canShuffle()) { return; }
    letterHistory.push(state.letterKeys.slice());
    if (letterHistory.length > 20) { letterHistory.shift(); }
    state.letterKeys = randomKeys(effectiveLetters(), state.letterKeys);
    renderPreview();
    scheduleSave();
    track('shuffle_all');
  }
  function shuffleLetter(i) {
    var name = effectiveLetters();
    var ch = name[i];
    if (!ch || !index) { return; }
    var list = index[ch] || [];
    if (list.length < 2) { return; }
    var current = state.letterKeys[i];
    var next = current;
    for (var attempt = 0; attempt < 8 && next === current; attempt++) {
      next = list[Math.floor(Math.random() * list.length)].key;
    }
    letterHistory.push(state.letterKeys.slice());
    if (letterHistory.length > 20) { letterHistory.shift(); }
    state.letterKeys[i] = next;
    renderPreview();
    scheduleSave();
    track('shuffle_letter', { yor_letter: ch, yor_letter_position: i + 1 });
    // Brief highlight on the corresponding tile so eye follows the change.
    var tiles = el.strip.querySelectorAll('.nl-tile');
    var tile = tiles[i];
    if (tile) {
      tile.classList.add('nl-tile--pulse');
      setTimeout(function () { tile.classList.remove('nl-tile--pulse'); }, 250);
    }
  }
  function undoShuffle() {
    if (!letterHistory.length) { return; }
    state.letterKeys = letterHistory.pop();
    renderPreview();
    scheduleSave();
    track('shuffle_undo');
  }
  function variantByKey(key) {
    var list = index[key.charAt(0).toUpperCase()] || [];
    for (var i = 0; i < list.length; i++) { if (list[i].key === key) { return list[i]; } }
    return null;
  }
  function updateAnnotationExamples(keys) {
    var variant = index && keys && keys.length ? variantByKey(keys[0]) : null;
    var location = variant && variant.location ? variant.location : 'Your selected satellite location';
    var coordinates = variant && variant.coordinates ? variant.coordinates : '';
    if (el.annotationPlaceExample) { el.annotationPlaceExample.textContent = location; }
    if (el.annotationFullExample) {
      el.annotationFullExample.textContent = location + (coordinates ? ' · ' + coordinates : '');
    }
  }

  // --- preview ------------------------------------------------------------
  function fitPreviewContent() {
    var content = el.previewContent;
    if (!content) { return; }
    content.style.transform = 'none';
    var cs = getComputedStyle(el.preview);
    var availH = el.preview.clientHeight
      - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
    var availW = el.preview.clientWidth
      - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    var ch = content.scrollHeight, cw = content.scrollWidth;
    if (ch <= 0 || cw <= 0) { return; }
    var scale = Math.min(1, availH / ch, availW / cw);
    content.style.transform = scale < 1 ? 'scale(' + scale + ')' : 'none';
  }
  function applyFrame() {
    var cls = isFramed() ? FRAME_CLASS[state.frame] : null;
    var isCanvas = state.format === 'Canvas';
    var isPrintOnly = state.format === 'Print Only';
    el.preview.classList.remove(
      'frame-black', 'frame-white', 'frame-natural', 'frame-dark-brown',
      'nl-preview--framed', 'nl-preview--canvas', 'nl-preview--print-only'
    );
    if (cls) { el.preview.classList.add(cls); }
    el.preview.classList.toggle('nl-preview--framed', !!cls);
    el.preview.classList.toggle('nl-preview--canvas', isCanvas);
    el.preview.classList.toggle('nl-preview--print-only', isPrintOnly);
    if (el.previewStage) {
      el.previewStage.classList.toggle('nl-preview-stage--canvas', isCanvas);
    }
    if (el.previewInstruction) {
      el.previewInstruction.textContent = isCanvas
        ? 'Gallery-wrapped canvas preview · select a letter to change its image'
        : 'Select a letter to try another satellite image';
    }
  }
  var SHUFFLE_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
    + '<polyline points="16 3 21 3 21 8"/>'
    + '<line x1="4" y1="20" x2="21" y2="3"/>'
    + '<polyline points="21 16 21 21 16 21"/>'
    + '<line x1="15" y1="15" x2="21" y2="21"/>'
    + '<line x1="4" y1="4" x2="9" y2="9"/>'
    + '</svg>';

  function updatePreviewDescription(name) {
    if (!el.previewDescription) { return; }
    var bg = el.swatches && el.swatches.querySelector('.nl-swatch--active .nl-swatch__label');
    var background = bg ? bg.textContent.trim().toLowerCase() : 'selected';
    var annotation = state.annotationMode === 'full'
      ? 'place names and coordinates shown'
      : (state.annotationMode === 'place' ? 'place names shown' : 'letter annotations off');
    var finish = state.format === 'Canvas' ? 'gallery-wrapped canvas' : (state.format || 'print');
    if (isFramed() && state.frame) { finish += ', ' + state.frame.toLowerCase() + ' frame'; }
    el.previewDescription.textContent = (normalizedName(state.name) ? 'Live preview: ' : 'Example preview: ') +
      name + ' in ' + (layoutRows(name).length === 2 ? 'two rows' : 'one row') +
      ' on a ' + background + ' background; ' + annotation + '; ' + finish + '.';
  }

  function paintTileAnnotation(tile, variant, textColor) {
    var label = tile.querySelector('.nl-tile-label');
    if (state.annotationMode === 'none') {
      if (label) { label.remove(); }
      return;
    }
    if (!label) {
      label = document.createElement('div');
      label.className = 'nl-tile-label';
      tile.appendChild(label);
    }
    label.style.color = textColor;
    label.innerHTML = '<div class="nl-tile-loc">' + escapeHtml(variant.location) + '</div>' +
      (state.annotationMode === 'full' ? coordLines(variant.coordinates) : '');
  }

  function buildPreviewStructure(rows, rowUnits, maxUnits) {
    el.strip.innerHTML = '';
    el.strip.className = 'nl-strip nl-strip--' + (rows.length === 2 ? 'two-row' : 'single-row');
    var slotIdx = 0;
    rows.forEach(function (row, rowIdx) {
      var line = document.createElement('div');
      line.className = 'nl-strip__line';
      line.style.width = ((rowUnits[rowIdx] / maxUnits) * 100).toFixed(2) + '%';
      for (var charIdx = 0; charIdx < row.length; charIdx++) {
        if (row[charIdx] === ' ') {
          var wordGap = document.createElement('span');
          wordGap.className = 'nl-word-gap';
          wordGap.setAttribute('aria-hidden', 'true');
          line.appendChild(wordGap);
          continue;
        }
        var tile = document.createElement('button');
        tile.type = 'button';
        tile.className = 'nl-tile';
        tile.dataset.slotIndex = String(slotIdx);
        var img = document.createElement('img');
        img.loading = 'eager';
        img.alt = '';
        if (slotIdx < 4) { img.fetchPriority = 'high'; }
        tile.appendChild(img);
        // Desktop hover affordance: a shuffle badge over the image so the
        // "select a letter to try another image" behaviour is discoverable.
        var badge = document.createElement('span');
        badge.className = 'nl-tile__shuffle';
        badge.setAttribute('aria-hidden', 'true');
        badge.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="16 3 21 3 21 8"/><line x1="4" y1="20" x2="21" y2="3"/><polyline points="21 16 21 21 16 21"/><line x1="15" y1="15" x2="21" y2="21"/><line x1="4" y1="4" x2="9" y2="9"/></svg>';
        tile.appendChild(badge);
        tile.addEventListener('click', function () {
          var position = Number(this.dataset.slotIndex);
          if (this.classList.contains('nl-tile--error')) {
            retryTileImage(position);
            return;
          }
          if (canShuffleLetter(position)) { shuffleLetter(position); }
        });
        line.appendChild(tile);
        slotIdx++;
      }
      el.strip.appendChild(line);
    });
  }

  function updateTileButtonLabel(tile, slotIdx) {
    if (!tile) { return; }
    var letters = lettersOnly(effectiveName());
    var letter = letters[slotIdx] || '';
    var shuffleable = canShuffleLetter(slotIdx);
    tile.setAttribute('aria-label', shuffleable
      ? 'Try another satellite image for letter ' + letter + ', position ' + (slotIdx + 1)
      : 'Letter ' + letter + ' has one satellite image');
    if (shuffleable) { tile.removeAttribute('aria-disabled'); }
    else { tile.setAttribute('aria-disabled', 'true'); }
  }

  function retryTileImage(slotIdx) {
    var tile = el.strip && el.strip.querySelector('.nl-tile[data-slot-index="' + slotIdx + '"]');
    var key = state.letterKeys[slotIdx];
    var variant = variantByKey(key);
    var image = tile && tile.querySelector('img');
    if (!tile || !variant || !image) { return; }
    track('preview_image_retry', { yor_letter: key.split('_')[0], yor_position: slotIdx + 1 });
    announce('Retrying satellite image.');
    attachWithFallback(image, variant, key, slotIdx);
  }

  function renderPreview() {
    if (el.shuffle) { el.shuffle.disabled = !canShuffle(); }
    if (el.undo) { el.undo.disabled = letterHistory.length === 0; }
    if (el.sampleBadge) { el.sampleBadge.hidden = normalizedName(state.name).length > 0; }
    updateNameCounter();
    el.preview.style.background = state.backgroundColor;
    if (el.previewStage) {
      el.previewStage.style.setProperty('--nl-canvas-edge-color', state.backgroundColor);
    }
    var textColor = isLight(state.backgroundColor) ? '#141418' : '#ebebee';
    // Always hide the empty state; effectiveName() ensures LANDSAT fallback.
    el.previewEmpty.style.display = 'none';
    var name = effectiveName();
    var letters = lettersOnly(name);
    // If keys don't yet match (manifest still loading), derive and retain them.
    var keys = state.letterKeys.length === letters.length ? state.letterKeys : chooseLetterKeys(letters);
    if (state.letterKeys !== keys) { state.letterKeys = keys; }
    updateAnnotationExamples(keys);
    if (!keys.length) {
      el.strip.innerHTML = '';
      delete el.strip.dataset.layoutSignature;
      el.previewCaption.textContent = '';
      applyFrame();
      renderShuffleToolbar();
      updatePreviewDescription(name);
      return;
    }
    var rows = layoutRows(name);
    var rowUnits = rows.map(function (row) {
      return lettersOnly(row).length + Math.max(0, nameWords(row).length - 1) * 0.55;
    });
    var maxUnits = Math.max.apply(null, rowUnits);
    var signature = rows.join('\u001e');
    if (el.strip.dataset.layoutSignature !== signature) {
      buildPreviewStructure(rows, rowUnits, maxUnits);
      el.strip.dataset.layoutSignature = signature;
    }
    Array.prototype.forEach.call(el.strip.querySelectorAll('.nl-tile'), function (tile) {
      var slotIdx = Number(tile.dataset.slotIndex);
      var key = keys[slotIdx];
      var variant = variantByKey(key);
      var image = tile.querySelector('img');
      if (!variant || !image) { tile.hidden = true; return; }
      tile.hidden = false;
      tile.style.removeProperty('display');
      updateTileButtonLabel(tile, slotIdx);
      if (tile.dataset.variantKey !== key || image.dataset.variantKey !== key) {
        tile.dataset.variantKey = key;
        image.dataset.variantKey = key;
        attachWithFallback(image, variant, key, slotIdx);
      }
      paintTileAnnotation(tile, variant, textColor);
    });
    el.previewCaption.textContent = state.caption;
    el.previewCaption.style.color = textColor;
    applyFrame();
    renderShuffleToolbar();
    updatePreviewDescription(name);
    requestAnimationFrame(fitPreviewContent);
  }

  // --- shuffle toolbar ----------------------------------------------------
  // Builds the per-letter chip row reactively whenever the name changes.
  function renderShuffleToolbar() {
    if (!el.letterChips) { return; }
    el.letterChips.innerHTML = '';
    var rows = layoutRows(effectiveName());
    var isGrouped = rows.length === 2;
    el.letterChips.classList.toggle('nl-letter-chips--grouped', isGrouped);
    el.letterChips.setAttribute('aria-label', isGrouped
      ? 'Shuffle individual letters, grouped by artwork row'
      : 'Shuffle individual letters');
    var flatIndex = 0;

    function appendChip(parent, idx, ch) {
      var list = (index && index[ch]) ? index[ch] : [];
      var canShuffleThis = list.length > 1;
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'nl-letter-chip' + (canShuffleThis ? '' : ' nl-letter-chip--disabled');
      chip.setAttribute('aria-label', 'Reshuffle letter ' + ch + ', position ' + (idx + 1));
      if (!canShuffleThis) {
        chip.setAttribute('aria-disabled', 'true');
        chip.setAttribute('title', 'Only one variant available');
      }
      var smallSvg = '<svg class="nl-letter-chip__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
        + '<polyline points="16 3 21 3 21 8"/>'
        + '<line x1="4" y1="20" x2="21" y2="3"/>'
        + '<polyline points="21 16 21 21 16 21"/>'
        + '<line x1="15" y1="15" x2="21" y2="21"/>'
        + '<line x1="4" y1="4" x2="9" y2="9"/>'
        + '</svg>';
      chip.innerHTML = smallSvg + '<span class="nl-letter-chip__letter">' + escapeHtml(ch) + '</span>';
      if (canShuffleThis) {
        chip.addEventListener('click', function () { shuffleLetter(idx); });
      }
      parent.appendChild(chip);
    }

    rows.forEach(function (row, rowIndex) {
      var chipParent = el.letterChips;
      if (isGrouped) {
        var group = document.createElement('div');
        group.className = 'nl-letter-chip-group';
        group.setAttribute('aria-label', rowIndex === 0 ? 'Top row' : 'Bottom row');
        var label = document.createElement('span');
        label.className = 'nl-letter-chip-group__label';
        label.textContent = rowIndex === 0 ? 'Top row' : 'Bottom row';
        group.appendChild(label);
        chipParent = document.createElement('div');
        chipParent.className = 'nl-letter-chip-row';
        group.appendChild(chipParent);
        el.letterChips.appendChild(group);
      }
      for (var charIndex = 0; charIndex < row.length; charIndex++) {
        if (row[charIndex] === ' ') {
          var gap = document.createElement('span');
          gap.className = 'nl-letter-chip-gap';
          gap.setAttribute('aria-hidden', 'true');
          chipParent.appendChild(gap);
        } else {
          appendChip(chipParent, flatIndex, row[charIndex]);
          flatIndex++;
        }
      }
    });
  }

  // --- variant resolution -------------------------------------------------
  function resolveVariant() {
    var wantFrame = isFramed() ? state.frame : 'No Frame';
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.format === state.format && v.size === state.size && v.frame === wantFrame) {
        return v;
      }
    }
    return null;
  }

  // --- pickers ------------------------------------------------------------
  var tooltipDismissBound = false;
  function closeOpenTooltips(except) {
    Array.prototype.forEach.call(document.querySelectorAll('.nl-tooltip-open'), function (shell) {
      if (shell === except) { return; }
      shell.classList.remove('nl-tooltip-open');
      var trigger = shell.querySelector('.nl-tooltip-trigger');
      if (trigger) { trigger.setAttribute('aria-expanded', 'false'); }
    });
  }
  function bindTooltipTrigger(trigger, shell) {
    if (!trigger || !shell) { return; }
    trigger.addEventListener('click', function (event) {
      event.stopPropagation();
      // Hover-capable devices reveal help with hover/focus. Touch devices need
      // an explicit tap toggle because they have no reliable hover state.
      var touchOnly = window.matchMedia && window.matchMedia('(hover: none)').matches;
      if (!touchOnly) { return; }
      var willOpen = !shell.classList.contains('nl-tooltip-open');
      closeOpenTooltips(shell);
      shell.classList.toggle('nl-tooltip-open', willOpen);
      trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });
    if (!tooltipDismissBound) {
      tooltipDismissBound = true;
      document.addEventListener('click', function () { closeOpenTooltips(); });
    }
  }
  function buildOptionButtons(container, values, current, cls, onPick, optionKind) {
    container.innerHTML = '';
    values.forEach(function (val) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = cls + (val === current ? ' ' + cls + '--active' : '');
      btn.dataset.value = val;
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', val === current ? 'true' : 'false');
      if (optionKind) { btn.dataset.optionKind = optionKind; }
      var label = val.toUpperCase().replace(/X/g, '\xd7'); // x -> × for sizes
      var icon = FORMAT_ICONS[val] || '';
      var help = optionKind === 'format' ? FORMAT_HELP[val] : '';
      var helpId = help ? 'nl-format-tooltip-' + val.toLowerCase().replace(/[^a-z0-9]+/g, '-') : '';
      btn.innerHTML = icon + '<span class="nl-card__label-row"><span class="nl-card__label">' + escapeHtml(label) + '</span>' +
        '</span>' +
        '<span class="nl-card__meta" aria-hidden="true"></span>';
      btn.addEventListener('click', function () { onPick(val); });
      if (help) {
        var shell = document.createElement('div');
        shell.className = 'nl-option-shell';
        shell.appendChild(btn);
        var trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = 'nl-tooltip-trigger';
        trigger.setAttribute('aria-label', 'More information about ' + val);
        trigger.setAttribute('aria-describedby', helpId);
        trigger.setAttribute('aria-expanded', 'false');
        trigger.textContent = '?';
        shell.appendChild(trigger);
        var tooltip = document.createElement('span');
        tooltip.className = 'nl-tooltip';
        tooltip.id = helpId;
        tooltip.setAttribute('role', 'tooltip');
        tooltip.textContent = help;
        shell.appendChild(tooltip);
        bindTooltipTrigger(trigger, shell);
        container.appendChild(shell);
      } else {
        container.appendChild(btn);
      }
    });
  }
  function markActive(container, cls, value) {
    Array.prototype.forEach.call(container.querySelectorAll('.' + cls), function (b) {
      var active = (b.dataset.value || b.dataset.frame) === value;
      b.classList.toggle(cls + '--active', active);
      if (b.getAttribute('role') === 'radio') { b.setAttribute('aria-checked', active ? 'true' : 'false'); }
    });
  }

  // "Available" means a variant exists AND is in stock - variant.available is
  // false for a tracked variant at 0 (or negative) stock with a deny policy.
  function hasAnyVariant(format, size) {
    return variants.some(function (v) {
      return v.format === format && v.size === size && v.available;
    });
  }
  function frameAvailable(size, colour) {
    return variants.some(function (v) {
      return v.format === 'Framed Print' && v.size === size && v.frame === colour && v.available;
    });
  }

  function selectableVariants(filter) {
    return variants.filter(function (v) { return filter(v) && v.available && !v.ukOnly; });
  }

  function setOptionAvailability(button, choices, active) {
    if (!button) { return; }
    var available = choices.filter(function (v) { return v.available && !v.ukOnly; });
    var ukOnly = choices.length > 0 && !available.length && choices.some(function (v) { return v.ukOnly; });
    // Claim mode: size/format/frame are locked to the variant already paid
    // for, independent of live stock. This is the single choke point every
    // option button's disabled state passes through (format/size/frame all
    // call setOptionAvailability from refreshOptionMeta), so the lock is
    // enforced HERE rather than only by the one-off applyClaimLock() calls
    // at boot/hydrate — any caller that re-derives availability (in-stock
    // toggling, a future hydrate/select path, etc.) cascades through this
    // function, and a claim-locked button must never come back out of it
    // enabled. Do not remove this in the name of "simplifying" the
    // availability check — stock must lose to the lock, not the other way
    // round, or a customer can pick a different (unpaid) variant again.
    var claimLocked = !!(window.SkylitClaim && window.SkylitClaim.active &&
      button.closest('[data-claim-locked]'));
    button.disabled = available.length === 0 || claimLocked;
    if (claimLocked) { button.setAttribute('aria-disabled', 'true'); button.tabIndex = -1; }
    button.classList.toggle('nl-option--unavailable', available.length === 0);
    button.classList.toggle('nl-option--active', !!active);
    if (button.getAttribute('role') === 'radio') { button.setAttribute('aria-checked', active ? 'true' : 'false'); }
    var meta = button.querySelector('.nl-card__meta');
    if (!meta) { return; }
    if (!available.length) {
      meta.textContent = ukOnly ? 'UK only' : 'Sold out';
      return;
    }
    var minPrice = Math.min.apply(null, available.map(function (v) { return v.price; }));
    meta.textContent = (available.length > 1 ? 'From ' : '') + money(minPrice);
  }

  function refreshOptionMeta() {
    if (!el.formats || !el.sizes || !el.frames) { return; }
    Array.prototype.forEach.call(el.formats.querySelectorAll('.nl-option'), function (btn) {
      var value = btn.dataset.value;
      var choices = variants.filter(function (v) {
        var wantedFrame = value === 'Framed Print' ? state.frame : 'No Frame';
        return v.format === value && v.size === state.size && v.frame === wantedFrame;
      });
      if (!choices.length) {
        choices = variants.filter(function (v) { return v.format === value; });
      }
      setOptionAvailability(btn, choices, value === state.format);
    });
    Array.prototype.forEach.call(el.sizes.children, function (btn) {
      var value = btn.dataset.value;
      var choices = variants.filter(function (v) {
        return v.format === state.format && v.size === value &&
          (!isFramed() || v.frame === state.frame);
      });
      // If the current frame is unavailable at this size, show the size as
      // selectable when another frame colour can satisfy it; selectSize will
      // reconcile the frame automatically.
      if (!choices.some(function (v) { return v.available && !v.ukOnly; }) && isFramed()) {
        choices = variants.filter(function (v) { return v.format === state.format && v.size === value; });
      }
      setOptionAvailability(btn, choices, value === state.size);
    });
    Array.prototype.forEach.call(el.frames.children, function (btn) {
      var colour = btn.dataset.frame;
      var choices = variants.filter(function (v) {
        return v.format === 'Framed Print' && v.size === state.size && v.frame === colour;
      });
      setOptionAvailability(btn, choices, colour === state.frame);
      btn.classList.toggle('nl-frame-chip--active', colour === state.frame);
      btn.setAttribute('aria-checked', colour === state.frame ? 'true' : 'false');
    });
  }

  function reconcileSelection() {
    var exact = resolveVariant();
    if (exact && exact.available && !exact.ukOnly) { return; }
    var matches = selectableVariants(function (v) {
      return v.format === state.format && v.size === state.size;
    });
    if (!matches.length) {
      matches = selectableVariants(function (v) { return v.format === state.format; });
    }
    if (!matches.length) { matches = selectableVariants(function () { return true; }); }
    if (!matches.length) { return; }
    var target = matches[0];
    state.format = target.format;
    state.size = target.size;
    if (target.frame && target.frame !== 'No Frame') { state.frame = target.frame; }
    el.preview.style.setProperty('--nl-ar', SIZE_AR[state.size] || 1.414);
  }

  function applyAvailability() {
    reconcileSelection();
    markActive(el.formats, 'nl-option', state.format);
    markActive(el.sizes, 'nl-option', state.size);
    markActive(el.frames, 'nl-frame-chip', state.frame);
    refreshOptionMeta();
  }

  function renderFormats() {
    var formats = uniq(variants.map(function (v) { return v.format; }));
    state.format = formats[0] || '';
    buildOptionButtons(el.formats, formats, state.format, 'nl-option', selectFormat, 'format');
  }
  function selectFormat(val) {
    state.format = val;
    markActive(el.formats, 'nl-option', val);
    updateFrameSection();
    updateGiftTilesForFormat();
    applyAvailability();
    syncVariant();
    renderPreview();
    scheduleSave();
    if (!isHydrating) { track('option_changed', { yor_option: 'format', yor_value: val }); }
  }

  function renderFrames() {
    var colours = uniq(variants
      .filter(function (v) { return v.frame && v.frame !== 'No Frame'; })
      .map(function (v) { return v.frame; }));
    state.frame = colours[0] || '';
    el.frames.innerHTML = '';
    var thumbs = (window.nlFrameThumbs || {});
    colours.forEach(function (colour) {
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'nl-frame-chip' + (colour === state.frame ? ' nl-frame-chip--active' : '');
      chip.dataset.frame = colour;
      chip.setAttribute('aria-label', colour + ' frame');
      chip.setAttribute('role', 'radio');
      chip.setAttribute('aria-checked', colour === state.frame ? 'true' : 'false');
      var imgSrc = thumbs[colour] || '';
      chip.innerHTML =
        (imgSrc ? '<img src="' + imgSrc + '" alt="" loading="lazy">' : '') +
        '<span class="nl-card__label">' + escapeHtml(colour.toUpperCase()) + '</span>' +
        '<span class="nl-card__meta" aria-hidden="true"></span>';
      chip.addEventListener('click', function () { selectFrame(colour); });
      el.frames.appendChild(chip);
    });
  }
  function selectFrame(colour) {
    state.frame = colour;
    applyAvailability();
    syncVariant();
    renderPreview();
    scheduleSave();
    if (!isHydrating) { track('option_changed', { yor_option: 'frame', yor_value: colour }); }
  }
  function updateFrameSection() {
    if (isFramed()) { el.frameSection.removeAttribute('hidden'); }
    else { el.frameSection.setAttribute('hidden', ''); }
  }

  function renderSizes() {
    var sizes = uniq(variants.map(function (v) { return v.size; }));
    state.size = sizes[0] || '';
    buildOptionButtons(el.sizes, sizes, state.size, 'nl-option', selectSize, 'size');
    el.preview.style.setProperty('--nl-ar', SIZE_AR[state.size] || 1.414);
  }
  function selectSize(val) {
    state.size = val;
    el.preview.style.setProperty('--nl-ar', SIZE_AR[val] || 1.414);
    applyAvailability();
    syncVariant();
    renderPreview();
    scheduleSave();
    if (!isHydrating) { track('option_changed', { yor_option: 'size', yor_value: val }); }
  }

  // --- draft save ---------------------------------------------------------
  function buildPayload() {
    var giftDom = readGiftDom();
    var wantsNote = (state.gift === 'ribbon' || state.gift === 'bundle') &&
      giftDom.enabled && giftDom.note.trim();
    return {
      order: orderId,
      design_version: 2,
      name_text: normalizedName(state.name),
      letter_keys: state.letterKeys,
      composition: effectiveComposition(),
      line_break_after: effectiveLineBreak(),
      caption: state.caption.trim(),
      show_coordinates: state.showCoordinates,
      annotation_mode: state.annotationMode,
      background_color: state.backgroundColor,
      size: state.size,
      selected_type: state.format,
      selected_frame: isFramed() ? state.frame : 'No Frame',
      gift_option: state.gift !== 'none' ? state.gift : null,
      gift_note: wantsNote ? giftDom.note : null,
      gift_card_design: wantsNote ? giftDom.design : null,
      gift_card_font: wantsNote ? giftDom.font : null,
      gift_note_enabled: wantsNote ? 1 : 0,
      device: { ua: navigator.userAgent, viewport: window.innerWidth + 'x' + window.innerHeight }
    };
  }
  function scheduleSave() {
    if (isHydrating) { return; }
    if (!nlAutosavePrimed) { return; } // resume modal pending — don't race it
    // Edit mode = the design is in the live cart. Its D1 row is what gets
    // printed, so unconfirmed edits must NOT autosave over it — the cart line
    // (Name/Caption properties) and the cart thumbnail are both snapshots taken
    // at add-to-cart and are NOT refreshed by an autosave, so the basket would
    // keep showing the old design while _print_url silently rendered the new
    // one. Order o3anmezphh8lchltj49po (2026-08-15) shipped through this hole:
    // added to cart as THOMAS, then edited to TAMMY on the way back, with the
    // cart, the thumbnail and the confirmation email all still saying THOMAS.
    // Edits persist only via "Confirm edits" (addToCart), same guard as
    // starmap-v2.js:scheduleAutosaveDraft, moon-myjs.js, hor-moon-myjs.js and
    // locationmap.js — YOR was the only customizer missing it. What they try
    // is still noted, on its own (cart-edit), for the admin to see.
    if (isEditMode) { scheduleCartEditLog(); return; }
    if (!state.name) { return; }
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      saveDraft().catch(function () { track('autosave_failed'); });
    }, SAVE_DEBOUNCE);
  }
  // Edit mode only: the options tried on a carted design, sent to the admin's
  // cart-edit log and never to the design itself (name-landsat-data).
  // Fire-and-forget; a failure changes nothing for the customer. Debounced
  // longer than the draft save so a run of letter swaps is one entry.
  var cartEditTimer = null;
  function scheduleCartEditLog() {
    if (!orderId || !state.letterKeys.length) { return; }
    clearTimeout(cartEditTimer);
    cartEditTimer = setTimeout(function () {
      cartEditTimer = null;
      try {
        fetch(ADMIN_BASE + 'api/cart-edit', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ product_type: 'name_landsat', data: buildPayload() })
        }).catch(function () {});
      } catch (e) {}
    }, 2500);
  }
  function saveDraft(funnelStatus) {
    if (!state.letterKeys.length) {
      var emptyError = new Error('The preview is not ready to save yet.');
      emptyError.code = 'design_save_failed';
      return Promise.reject(emptyError);
    }
    // funnel_status: 'draft' for debounced autosaves, 'cart' from addToCart —
    // the backend's no-regress guard keeps later autosaves from demoting it.
    var payload = buildPayload();
    payload.funnel_status = funnelStatus || 'draft';
    var opts = { method: 'POST', headers: { 'Content-Type': 'application/json' },
                 body: JSON.stringify(payload) };
    function post() { return fetch(API, opts); }
    function requireOk(r) {
      if (!r || !r.ok) {
        var error = new Error('We could not securely save your design.');
        error.code = 'design_save_failed';
        throw error;
      }
      return r;
    }
    track('design_save_started', { yor_save_context: payload.funnel_status });
    return post().then(requireOk).catch(function () {
      return post().then(requireOk);
    }).then(function (r) {
      // The save response still carries a cart-thumbnail capability token for
      // the /api/cart-thumbnail-cf endpoint. Nothing in this file fires that
      // endpoint any more (the save route triggers the render itself), so the
      // token is captured only for the draft-pointer chain's shape.
      return r.clone().json().catch(function () { return null; }).then(function (data) {
        if (data && data.cart_thumbnail_token) { nlCartThumbnailToken = data.cart_thumbnail_token; }
        // Pointer written only after the save actually lands, so it never
        // points at a row the backend has never seen.
        writeDraftPointer();
        track('design_save_succeeded', { yor_save_context: payload.funnel_status });
        return r;
      });
    }).catch(function (error) {
      track('design_save_failed', { yor_save_context: payload.funnel_status });
      if (!error.code) { error.code = 'design_save_failed'; }
      throw error;
    });
  }

  // --- letter-strip thumbnail rasteriser -----------------------------------
  // Captures the current strip of letter tiles as a canvas thumbnail.
  // NOTE (2026-08-11): this used to ALSO be the cart-thumbnail-cf upload
  // path (via generateAndUploadThumbnail, below) — that path now goes
  // through the server-rendered CF Browser Rendering pipeline instead,
  // triggered by the name-landsat-data save. This function is kept because
  // buildThumbnailDataUrl() (the "save for later" email flow, further down)
  // still uses it for the thumbnail embedded in that email — a client
  // rasterisation is exactly right there since it needs to run instantly in
  // the browser with no server round-trip. Falls back silently if the strip
  // is empty.
  function buildLayoutThumbnailDataUrl(done) {
    try {
      var lineEls = Array.prototype.slice.call(el.strip.querySelectorAll('.nl-strip__line'));
      var allTiles = el.strip.querySelectorAll('.nl-tile img');
      if (!lineEls.length || !allTiles.length) { done(''); return; }
      var tileW = 40;
      var tileH = Math.round(tileW * (2704 / 1128));
      var gap = 2, wordGap = 20, rowGap = 7, captionH = 16;
      function lineWidth(line) {
        var width = 0, previousTile = false;
        Array.prototype.forEach.call(line.children, function (child) {
          if (child.classList.contains('nl-word-gap')) {
            width += wordGap;
            previousTile = false;
          } else {
            if (previousTile) { width += gap; }
            width += tileW;
            previousTile = true;
          }
        });
        return width;
      }
      var widths = lineEls.map(lineWidth);
      var totalW = Math.max.apply(null, widths);
      var artworkH = lineEls.length * tileH + (lineEls.length - 1) * rowGap;
      var totalH = artworkH + captionH;
      var canvas = document.createElement('canvas');
      canvas.width = totalW;
      canvas.height = totalH;
      var ctx = canvas.getContext('2d');
      ctx.fillStyle = state.backgroundColor || '#0e0e12';
      ctx.fillRect(0, 0, totalW, totalH);
      var pending = allTiles.length;
      function finishOne() {
        pending--;
        if (pending > 0) { return; }
        if (state.caption) {
          ctx.fillStyle = isLight(state.backgroundColor || '#0e0e12') ? '#141418' : '#ebebee';
          ctx.font = '9px Josefin Sans, sans-serif';
          ctx.textAlign = 'center';
          ctx.fillText(state.caption.slice(0, 40), totalW / 2, artworkH + 12);
        }
        try { done(canvas.toDataURL('image/jpeg', 0.8)); } catch (e) { done(''); }
      }
      lineEls.forEach(function (line, rowIdx) {
        var x = (totalW - widths[rowIdx]) / 2;
        var y = rowIdx * (tileH + rowGap);
        var previousTile = false;
        Array.prototype.forEach.call(line.children, function (child) {
          if (child.classList.contains('nl-word-gap')) {
            x += wordGap;
            previousTile = false;
            return;
          }
          if (previousTile) { x += gap; }
          var img = child.querySelector('img');
          var drawX = x;
          x += tileW;
          previousTile = true;
          if (img.complete && img.naturalWidth > 0) {
            try { ctx.drawImage(img, drawX, y, tileW, tileH); } catch (e) {}
            finishOne();
          } else {
            var tmp = new Image();
            tmp.crossOrigin = 'anonymous';
            tmp.onload = function () {
              try { ctx.drawImage(tmp, drawX, y, tileW, tileH); } catch (e) {}
              finishOne();
            };
            tmp.onerror = finishOne;
            tmp.src = img.src;
          }
        });
      });
    } catch (e) { done(''); }
  }

  // --- cart thumbnail ----------------------------------------------------
  // Rendered server-side, triggered inside the saveDraft('cart') POST that
  // add-to-cart already awaits (admin app/api/name-landsat-data → the shared
  // cart-thumbnail trigger). It used to be a separate fire-and-forget POST to
  // /api/cart-thumbnail-cf from here, which raced the navigation to /cart and
  // was sometimes dropped before it left the device even with keepalive set.
  // The render screenshots the SAME .nl-preview element the customer approved
  // (app/%5Finternal/name-landsat-preview-host drives this script headlessly)
  // and composites it into the landscape lifestyle mockup.

  // --- add to cart (with edit-mode support) -------------------------------
  // Ported pattern from custom-print.js:submitToCart and starmap-v2:addToCart:
  //   1. Save draft to admin first.
  //   2. If order is already in cart, remove old line + re-add (update).
  //   3. If not in cart, just add.
  //   4. Log order-event edit_personalisations_confirmed when in edit mode.
  //   5. Upload cart thumbnail (fire-and-forget).
  //   6. Redirect to /cart.
  function addToCart() {
    // Claim mode: gate on `active` (a ?claim= token is present at all), NOT
    // on `claim`/`usable` being populated. The customer already paid once
    // through another channel — if we gated on `.claim`, an already-claimed
    // link, a still-loading lookup, or a transient fetch error would all
    // leave `.claim` null and fall straight through to the normal cart flow
    // below, letting them pay again for a print they already own. `active`
    // is set synchronously the instant the token is seen, so this check
    // can never race the async claim lookup.
    if (window.SkylitClaim && window.SkylitClaim.active) {
      if (!(window.SkylitClaim.usable && window.SkylitClaim.claim)) {
        showAddError(window.SkylitClaim.message ||
          'This design link cannot be used right now. Please contact hello@skylitstudio.co.uk.');
        return;
      }
      if (!state.name) { focusNameInput(); return; }
      if (!state.letterKeys.length) { focusNameInput(); return; }
      if (!state.variantId) { return; }
      // This design order was already paid for through another channel
      // (Shop app / TikTok) — there is no cart to add to. Save the finished
      // design as normal, then attach it to the paid Shopify order via the
      // claim endpoint instead of /cart/add.js. Returns here, never falling
      // through to the cart-line/pairing logic below, which assumes a fresh
      // checkout.
      setAddButtonState('Confirming…', true);
      track('add_to_cart_started');
      return saveDraft('cart').then(function () {
        return window.SkylitClaim.complete(orderId);
      }).catch(function (err) {
        console.error('[claim] confirm failed', err);
        syncVariant();
        var msg = err && err.code === 'design_save_failed'
          ? 'We could not securely save your design. Check your connection and try again.'
          : 'We could not confirm your design. Please try again or contact hello@skylitstudio.co.uk.';
        track('add_to_cart_failed', { yor_error_type: 'claim_confirm', yor_error_message: msg.slice(0, 160) });
        showAddError(msg);
      });
    }

    if (!state.name) { focusNameInput(); return; }
    if (!state.letterKeys.length) { focusNameInput(); return; }
    if (!state.variantId) { return; }

    setAddButtonState(isEditMode ? 'Updating…' : 'Adding…', true);
    track('add_to_cart_started');
    // Confirming saves the design itself; a still-pending "tried" note is moot.
    clearTimeout(cartEditTimer);

    saveDraft('cart').then(function () {
      var props = {
        _OrderID: orderId,
        'Name': normalizedName(state.name),
        'Template': effectiveComposition() === 'two-row' ? 'Two rows' : 'One row',
        'Format': state.format,
        'Coordinates': state.annotationMode === 'full' ? 'Shown'
          : state.annotationMode === 'place' ? 'Places only' : 'Hidden',
        _print_url: ADMIN_BASE + 'api/download/' + orderId,
        _thumbnail_final: ADMIN_BASE + 'api/cart-thumbnail-img/' + orderId,
        // The BARE print (no room, no frame). The cart composes the scene
        // live in CSS around this, so a frame bought from the cart's own
        // upsell appears instantly instead of needing a re-render. Falls
        // back to _thumbnail_final's baked composite when this 404s.
        _thumbnail_print: ADMIN_BASE + 'api/cart-print-img/' + orderId,
        _selected_type: state.format,
        // Canonical size token ('40x50') — the variant label ('40 x 50cm')
        // stripped of spaces/cm, matching the admin webhook / renderer keys.
        _selected_size: String(state.size || '').replace(/cm/gi, '').replace(/\s+/g, ''),
        _selected_frame: isFramed() ? state.frame : 'No Frame',
        _show_coordinates: state.showCoordinates ? '1' : '0',
        _annotation_mode: state.annotationMode,
        _background_color: state.backgroundColor
      };
      props._orientation = 'landscape';
      if (window.SkylitGalleryWall) { window.SkylitGalleryWall.applyProperties(props); }
      if (isFramed()) { props['Frame'] = state.frame; }
      var cap = state.caption.trim();
      if (cap) { props['Caption'] = cap; props['_caption'] = cap; }

      // One fresh copy reference per add-to-cart, shared by the print and its
      // paired add-on. _OrderID is shared between copies of one design, so the
      // cart/drawer controls pair add-ons on this instead.
      var lineRef = window.SkylitPairing ? window.SkylitPairing.makeLineRef() : orderId;
      props['_cart_line_ref'] = lineRef;

      var items = [{ id: parseInt(state.variantId, 10), quantity: 1, properties: props }];

      // Paired gift add-on line (star-style single multi-item add — atomic).
      if (state.gift !== 'none' && GIFT_IDS[state.gift]) {
        var giftDom = readGiftDom();
        var giftProps = { _paired_with_order_id: orderId, _paired_with_line_ref: lineRef };
        if (state.gift === 'ribbon' || state.gift === 'bundle') {
          giftProps['Ribbon Colour'] = state.ribbonColor || 'Red';
          giftProps._ribbon_color = state.ribbonColor || 'Red';
          if (giftDom.enabled && giftDom.note.trim()) {
            giftProps._gift_note = giftDom.note;
            giftProps._gift_card_design = giftDom.design;
            giftProps._gift_card_font = giftDom.font;
          }
        }
        if (state.gift === 'giftwrap' || state.gift === 'bundle') {
          var nlPaperKey = window.SkylitGifts ? window.SkylitGifts.designKey(state.giftPaper) : 'regular';
          giftProps['Gift Wrap Theme'] = window.SkylitGifts ? window.SkylitGifts.labelFor(nlPaperKey) : 'Regular';
          giftProps._gift_wrap_theme = nlPaperKey;
        }
        // Wrap/bundle are size-tiered by the print; GIFT_IDS (smallest
        // tier) is the fallback when the shared map is missing.
        var nlGiftId = GIFT_IDS[state.gift];
        try {
          var nlTiered = window.SkylitGifts && window.SkylitGifts.variantFor(state.gift, state.size, state.giftPaper);
          if (nlTiered) nlGiftId = String(nlTiered);
        } catch (e) {}
        items.push({ id: parseInt(nlGiftId, 10), quantity: 1, properties: giftProps });
      }
      // Bundle bookkeeping cart attributes (cart-footer promo + custom-bundle
      // SKU logic read these) — always set _custom_bundle_active.
      var giftAttrs = { _custom_bundle_active: state.gift === 'bundle' ? 'true' : 'false' };
      if (state.gift === 'bundle') { giftAttrs._custom_bundle_quantity = '1'; }

      var addItem = { items: items };

      var doAdd = function () {
        return fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(addItem)
        });
      };

      // Drop anything this design already owns in the cart (print + paired
      // ribbon/wrap/bundle/wall strips) before adding, driven by a LIVE cart
      // read rather than the page-load snapshot.
      if (window.SkylitPairing) {
        return window.SkylitPairing.purgeDesign(orderId)
          .then(doAdd)
          .then(function (r) {
            return fetch('/cart/update.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ attributes: giftAttrs })
            }).then(function () { return r; }, function () { return r; });
          });
      }

      // Helper missing (asset blocked) — re-fetch cart inline instead.
      return fetch('/cart.js?t=' + Date.now())
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var freshIds = [], freshKeys = [];
          (cart.items || []).forEach(function (item) {
            var iid = item.properties && (item.properties._OrderID || item.properties.OrderID);
            if (iid) { freshIds.push(iid); freshKeys.push(item.key); }
          });
          var orderIndex = freshIds.indexOf(orderId);
          var inCart = orderIndex !== -1;

          if (inCart) {
            // Edit: remove old line first, then add updated version.
            var oldKey = freshKeys[orderIndex];
            console.log('[Name Landsat] edit-replace: remove', oldKey, 'then re-add');
            window.__skylitCartEditInFlight = true;
            // Also remove any paired add-on lines linked to this orderId
            // (gift wrap etc.) so switching mid-edit doesn't duplicate them.
            var pairedKeys = (cart.items || [])
              .filter(function (li) {
                return li.properties &&
                  li.properties._paired_with_order_id === orderId;
              })
              .map(function (li) { return li.key; });

            var chain = fetch('/cart/change.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: oldKey, quantity: 0 })
            });
            pairedKeys.forEach(function (pk) {
              chain = chain.then(function () {
                return fetch('/cart/change.js', {
                  method: 'POST', headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: pk, quantity: 0 })
                });
              });
            });
            return chain.then(function () {
              return fetch('/cart/add.js', {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(addItem)
              });
            });
          }
          // Fresh add (draft or first visit).
          return fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(addItem)
          });
        })
        .then(function (r) {
          // Stamp the bundle bookkeeping attributes after the lines land.
          return fetch('/cart/update.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: giftAttrs })
          }).then(function () { return r; }, function () { return r; });
        });
    }).then(function (r) {
      if (r && r.ok) {
        track('add_to_cart_succeeded');
        // Log confirmed-edit event (fire-and-forget; 404s silently when
        // name_landsat is not yet in the order-event TABLES list).
        if (isEditMode) { logOrderEvent('edit_personalisations_confirmed'); }
        window.location.href = window.SkylitGalleryWall ? window.SkylitGalleryWall.destination() : '/cart';
        return;
      }
      // Non-OK response — read Shopify's error body so we can surface its
      // actual message (e.g. "The maximum quantity of this item is already in
      // your cart" when a stock-limited variant is already in basket) rather
      // than a generic "something went wrong".
      return r.json().catch(function () { return {}; }).then(function (data) {
        var msg = (data && (data.description || data.message)) ||
                  'We could not add this to your basket. Please try again.';
        throw msg;
      });
    }).catch(function (err) {
      syncVariant();
      var msg = err && err.code === 'design_save_failed'
        ? 'We could not securely save your design. Check your connection and try Add to basket again.'
        : (typeof err === 'string'
          ? err
          : 'We could not add this to your basket. Please try again.');
      track('add_to_cart_failed', {
        yor_error_type: err && err.code === 'design_save_failed' ? 'design_save' : 'shopify_cart',
        yor_error_message: msg.slice(0, 160)
      });
      showAddError(msg);
    });
  }

  // --- inline add-to-cart error surface ------------------------------------
  // Replaces the previous alert() with a non-intrusive inline message under
  // the Add button. Auto-clears when the customer changes any picker (since
  // the new combination might be fine).
  function showAddError(msg) {
    var slot = document.getElementById('nl-add-error');
    if (!slot) {
      slot = document.createElement('p');
      slot.id = 'nl-add-error';
      slot.className = 'nl-add-error';
      slot.setAttribute('role', 'alert');
      slot.setAttribute('aria-live', 'polite');
      el.add.insertAdjacentElement('afterend', slot);
    }
    slot.textContent = msg;
    slot.hidden = false;
    slot.style.display = '';
    if (el.mobileError) {
      el.mobileError.textContent = msg;
      el.mobileError.hidden = false;
    }
  }
  function clearAddError() {
    var slot = document.getElementById('nl-add-error');
    if (slot) { slot.hidden = true; }
    if (el.mobileError) { el.mobileError.hidden = true; }
  }

  // --- annotation mode ------------------------------------------------------
  function setAnnotationMode(mode) {
    if (mode !== 'full' && mode !== 'place' && mode !== 'none') { mode = 'full'; }
    state.annotationMode = mode;
    state.showCoordinates = mode !== 'none'; // legacy mirror
    if (el.annotation) {
      Array.prototype.forEach.call(el.annotation.querySelectorAll('[data-mode]'), function (b) {
        var active = b.dataset.mode === mode;
        b.classList.toggle('nl-option--active', active);
        b.setAttribute('aria-checked', active ? 'true' : 'false');
      });
    }
    renderPreview();
    updateSectionSummaries();
    if (!isHydrating) { track('option_changed', { yor_option: 'annotations', yor_value: mode }); }
  }

  // --- caption idea chips -----------------------------------------------------
  function renderCaptionChips() {
    if (!el.captionChips) { return; }
    var year = new Date().getFullYear();
    var ideas = [
      'Written in the Earth',
      'Est. ' + year,
      'Love you to Earth and back',
      'Our little explorer'
    ];
    el.captionChips.innerHTML = '';
    ideas.forEach(function (text) {
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'nl-caption-chip';
      chip.textContent = text;
      chip.addEventListener('click', function () {
        el.caption.value = text;
        state.caption = text;
        renderPreview();
        scheduleSave();
      });
      el.captionChips.appendChild(chip);
    });
  }

  // --- gift wrapping ----------------------------------------------------------
  function readGiftDom() {
    var out = { note: '', design: 'editorial', font: 'handwritten', enabled: false };
    var ta = document.getElementById('Gift-note-namelandsat');
    if (ta) { out.note = ta.value || ''; }
    var root = document.querySelector('.gnc[data-gnc="namelandsat"]');
    if (root) {
      var d = root.getAttribute('data-design');
      if (d === 'editorial' || d === 'minimal') { out.design = d; }
      var f = root.getAttribute('data-font');
      if (f === 'handwritten' || f === 'classic') { out.font = f; }
      out.enabled = root.getAttribute('data-enabled') === 'true';
    }
    return out;
  }
  // Gift overlays on the preview (ribbon / wrapping paper), same behaviour as
  // the location map: visible while selected, peek button to look underneath.
  var giftPeekHidden = false;
  var nlPaperPicker = null;
  function applyRibbonColor() {
    var ribbon = document.getElementById('nl-ribbon-overlay');
    if (!ribbon) { return; }
    var color = RIBBON_COLORS[state.ribbonColor] ? state.ribbonColor : 'Red';
    ribbon.setAttribute('data-ribbon-color', color);
    if (window.SkylitGifts) {
      var src = window.SkylitGifts.ribbonImageFor(color, 'landscape');
      if (ribbon.getAttribute('src') !== src) ribbon.setAttribute('src', src);
    }
  }
  function applyGiftOverlays() {
    var g = giftPeekHidden ? 'none' : state.gift;
    var ribbonOn = (g === 'ribbon' || g === 'bundle');
    var wrapOn = (g === 'giftwrap' || g === 'bundle');
    var ro = document.getElementById('nl-ribbon-overlay');
    var wo = document.getElementById('nl-giftwrap-overlay');
    if (ro) ro.classList.toggle('visible', ribbonOn);
    if (wo) wo.classList.toggle('visible', wrapOn);
    if (wo && window.SkylitGifts) window.SkylitGifts.applyPaperTexture(wo, state.giftPaper);
    applyRibbonColor();
    // Note card rides the ribbon (same rule as the location map).
    var gc = document.getElementById('nl-giftcard-overlay');
    if (gc) gc.classList.toggle('visible', ribbonOn);
  }
  function refreshGiftPeekBtn() {
    var btn = document.getElementById('nl-gift-peek-btn');
    var active = state.gift && state.gift !== 'none';
    if (btn) {
      btn.hidden = !active;
      var label = giftPeekHidden ? 'Show gift wrap' : 'Hide gift wrap';
      btn.setAttribute('aria-label', label);
      btn.setAttribute('title', label);
      btn.setAttribute('aria-pressed', giftPeekHidden ? 'true' : 'false');
    }
    var notice = document.getElementById('nl-gift-peek-notice');
    if (notice) notice.hidden = !(active && giftPeekHidden);
  }
  (function bindGiftPeek() {
    var btn = document.getElementById('nl-gift-peek-btn');
    if (btn) {
      btn.addEventListener('click', function () {
        giftPeekHidden = !giftPeekHidden;
        applyGiftOverlays();
        refreshGiftPeekBtn();
      });
    }
    var showBtn = document.getElementById('nl-gift-peek-show');
    if (showBtn) {
      showBtn.addEventListener('click', function () {
        giftPeekHidden = false;
        applyGiftOverlays();
        refreshGiftPeekBtn();
      });
    }
  })();
  function setGift(gift) {
    if (!(gift in GIFT_PRICES)) { gift = 'none'; }
    state.gift = gift;
    if (el.giftGrid) {
      Array.prototype.forEach.call(el.giftGrid.querySelectorAll('[data-nl-gift]'), function (b) {
        var active = b.dataset.nlGift === gift;
        b.classList.toggle('nl-gift-tile--active', active);
        b.setAttribute('aria-checked', active ? 'true' : 'false');
      });
    }
    var wantsRibbon = gift === 'ribbon' || gift === 'bundle';
    if (el.ribbonColor) { el.ribbonColor.hidden = !wantsRibbon; }
    if (el.giftNoteSection) { el.giftNoteSection.hidden = !wantsRibbon; }
    var paperWrap = document.getElementById('nl-gift-paper-wrap');
    if (paperWrap) paperWrap.hidden = !(state.gift === 'giftwrap' || state.gift === 'bundle');
    giftPeekHidden = false; // changing selection re-shows the overlay
    applyGiftOverlays();
    refreshGiftPeekBtn();
    updateGiftTilesForFormat();
    syncVariant();
    saveGiftExtras();
    updateSectionSummaries();
    if (!isHydrating) { track('option_changed', { yor_option: 'gift', yor_value: gift }); }
  }
  // Rolled prints ship in a tube — gift wrap / bundle don't apply. Hide those
  // tiles for Print Only and stash/restore the choice (starmap pattern).
  function updateGiftTilesForFormat() {
    var isPrint = state.format === 'Print Only';
    if (el.ribbonTooltip) {
      // Swap the sentence + looping clip, never the whole tooltip: setting
      // textContent on the tooltip used to wipe the <img> and leave the ribbon
      // tooltip text-only for the rest of the session.
      var rbText = document.getElementById('nl-ribbon-tooltip-text');
      var rbMedia = document.getElementById('nl-ribbon-tooltip-media');
      var rbCopy = isPrint
        ? 'Print orders ship rolled in a protective tube. The ribbon is tied around the roll, ready to gift on arrival.'
        : 'The ribbon is tied directly around the frame or canvas, ready to gift on arrival.';
      if (rbText) { rbText.textContent = rbCopy; } else { el.ribbonTooltip.textContent = rbCopy; }
      if (rbMedia) {
        var rbSrc = isPrint ? rbMedia.dataset.srcPrint : rbMedia.dataset.srcWrapped;
        if (rbSrc && rbMedia.getAttribute('src') !== rbSrc) { rbMedia.setAttribute('src', rbSrc); }
      }
    }
    if (!el.giftGrid) { return; }
    Array.prototype.forEach.call(el.giftGrid.querySelectorAll('[data-hide-for-print]'), function (b) {
      b.hidden = isPrint;
    });
    if (isPrint && (state.gift === 'giftwrap' || state.gift === 'bundle')) {
      giftBeforePrint = state.gift;
      setGift('ribbon');
    } else if (!isPrint && giftBeforePrint) {
      var restore = giftBeforePrint;
      giftBeforePrint = null;
      setGift(restore);
    }
  }
  // Ribbon colour + gift choice persist per order id (ribbon colour has no
  // D1 column; the note itself rides on the row + paired cart line).
  function saveGiftExtras() {
    try {
      localStorage.setItem('nl_gift_' + orderId, JSON.stringify({
        gift: state.gift, ribbonColor: state.ribbonColor, giftPaper: state.giftPaper, ts: Date.now()
      }));
    } catch (e) {}
  }
  function loadGiftExtras(id) {
    try {
      var rec = JSON.parse(localStorage.getItem('nl_gift_' + id) || 'null');
      if (!rec) { return null; }
      if (rec.ts && (Date.now() - rec.ts) > 30 * 86400000) {
        localStorage.removeItem('nl_gift_' + id);
        return null;
      }
      return rec;
    } catch (e) { return null; }
  }
  // Push a saved/paired gift note back into the editor DOM (mirrors
  // starmap-v2 applyGiftNoteFromExtras — retries while the snippet boots).
  function applyGiftNote(note, design, font, enabled, _attempt) {
    _attempt = _attempt || 0;
    var root = document.querySelector('.gnc[data-gnc="namelandsat"]');
    if (!root) {
      if (_attempt < 20) { setTimeout(function () { applyGiftNote(note, design, font, enabled, _attempt + 1); }, 100); }
      return;
    }
    document.querySelectorAll('.gnc[data-gnc="namelandsat"]').forEach(function (n) {
      n.setAttribute('data-design', (design === 'minimal' ? 'minimal' : 'editorial'));
      n.setAttribute('data-font', (font === 'classic' ? 'classic' : 'handwritten'));
      n.setAttribute('data-enabled', (enabled && note) ? 'true' : 'false');
    });
    var ta = document.getElementById('Gift-note-namelandsat');
    if (ta) {
      ta.value = note || '';
      var cb = document.querySelector('.gnc[data-gnc="namelandsat"] [data-gnc-enabled]');
      if (cb) { cb.checked = !!(enabled && note); }
      ta.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
  function hydrateGiftNoteFromPairedAddon(cartItems) {
    var paired = (cartItems || []).filter(function (li) {
      return li.properties && li.properties._paired_with_order_id === orderId;
    })[0];
    if (!paired || !paired.properties) { return false; }
    var p = paired.properties;
    if (p._ribbon_color) {
      state.ribbonColor = p._ribbon_color;
      if (el.ribbonSwatches) {
        Array.prototype.forEach.call(el.ribbonSwatches.children, function (b) {
          var active = b.dataset.nlRibbonColor === state.ribbonColor;
          b.classList.toggle('nl-ribbon-swatch--active', active);
          b.setAttribute('aria-checked', active ? 'true' : 'false');
        });
      }
    }
    var pd = window.SkylitGifts && (window.SkylitGifts.designFor(paired.variant_id) || (p._gift_wrap_theme && window.SkylitGifts.designKey(p._gift_wrap_theme)));
    if (pd) { state.giftPaper = pd; if (nlPaperPicker) nlPaperPicker.set(pd); }
    if (p._gift_note) { applyGiftNote(p._gift_note, p._gift_card_design, p._gift_card_font, true); }
    return true;
  }

  // --- draft pointer + resume modal (hardened starmap pattern) ----------------
  var NL_DRAFT_KEY = 'nl_last_draft';
  var NL_DRAFT_TTL_MS = 30 * 86400000;
  function writeDraftPointer() {
    try {
      localStorage.setItem(NL_DRAFT_KEY, JSON.stringify({ orderId: orderId, ts: Date.now() }));
    } catch (e) {}
  }
  function primeAutosave() { nlAutosavePrimed = true; }

  function activateDialog(overlay, dialog, opener, initialFocus, onDismiss) {
    var closed = false;
    function focusableItems() {
      return Array.prototype.slice.call(dialog.querySelectorAll(
        'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'
      )).filter(function (node) { return !node.hidden; });
    }
    function close(dismissed) {
      if (closed) { return; }
      closed = true;
      document.removeEventListener('keydown', onKeydown, true);
      if (overlay.parentNode) { overlay.parentNode.removeChild(overlay); }
      if (opener && opener.focus) { opener.focus(); }
      if (dismissed && onDismiss) { onDismiss(); }
    }
    function onKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        close(true);
        return;
      }
      if (event.key !== 'Tab') { return; }
      var items = focusableItems();
      if (!items.length) { event.preventDefault(); dialog.focus(); return; }
      var first = items[0], last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); first.focus();
      }
    }
    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) { close(true); }
    });
    document.addEventListener('keydown', onKeydown, true);
    window.requestAnimationFrame(function () {
      (initialFocus || focusableItems()[0] || dialog).focus();
    });
    return close;
  }

  function showNlModal(opts) {
    var opener = document.activeElement;
    var overlay = document.createElement('div');
    overlay.id = 'nl-resume-modal';
    overlay.innerHTML =
      '<style>' +
      '#nl-resume-modal{position:fixed;inset:0;z-index:2147483646;display:flex;align-items:center;justify-content:center;background:rgba(20,18,16,0.55);backdrop-filter:blur(4px);-webkit-backdrop-filter:blur(4px);font-family:inherit;animation:nlrmFade 220ms ease-out}' +
      '#nl-resume-modal .nlrm-card{background:#f5efe6;color:#1c1a17;border-radius:14px;padding:26px 26px 22px;width:min(360px,86vw);box-shadow:0 18px 60px rgba(0,0,0,0.35);text-align:center;animation:nlrmPop 240ms cubic-bezier(.2,.9,.3,1.1)}' +
      '#nl-resume-modal h3{margin:0 0 6px;font-size:18px;font-weight:600;letter-spacing:.01em}' +
      '#nl-resume-modal p{margin:0 0 18px;font-size:13px;line-height:1.5;color:#6b6357}' +
      '#nl-resume-modal .nlrm-row{display:flex;gap:10px}' +
      '#nl-resume-modal button{flex:1;padding:11px 14px;border-radius:10px;border:1px solid #d6cdbf;background:#fff;color:#1c1a17;font:inherit;font-size:14px;cursor:pointer}' +
      '#nl-resume-modal button:hover{background:#ece4d6}' +
      '#nl-resume-modal button.nlrm-primary{background:#1c1a17;color:#f5efe6;border-color:#1c1a17}' +
      '#nl-resume-modal button.nlrm-primary:hover{background:#000}' +
      '@keyframes nlrmFade{from{opacity:0}to{opacity:1}}' +
      '@keyframes nlrmPop{from{transform:scale(.94);opacity:0}to{transform:scale(1);opacity:1}}' +
      '</style>' +
      '<div class="nlrm-card" role="dialog" aria-modal="true" aria-labelledby="nlrm-title" aria-describedby="nlrm-description" tabindex="-1">' +
        '<h3 id="nlrm-title"></h3><p id="nlrm-description"></p>' +
        '<div class="nlrm-row">' +
          '<button type="button" class="nlrm-dismiss"></button>' +
          '<button type="button" class="nlrm-primary"></button>' +
        '</div>' +
      '</div>';
    overlay.querySelector('h3').textContent = opts.title;
    overlay.querySelector('p').textContent = opts.body;
    overlay.querySelector('.nlrm-primary').textContent = opts.primaryLabel;
    overlay.querySelector('.nlrm-dismiss').textContent = opts.secondaryLabel;
    document.body.appendChild(overlay);
    var onDismiss = opts.onDismiss || function () {};
    var primary = overlay.querySelector('.nlrm-primary');
    var close = activateDialog(overlay, overlay.querySelector('.nlrm-card'), opener, primary, onDismiss);
    primary.addEventListener('click', function () { close(false); opts.onPrimary(); });
    overlay.querySelector('.nlrm-dismiss').addEventListener('click', function () { close(false); opts.onSecondary(); });
  }

  function maybeShowResumeModal() {
    // Boot withholds autosave priming whenever a pointer exists; every early
    // return here must prime autosave itself or the session saves nothing.
    try {
      var raw = localStorage.getItem(NL_DRAFT_KEY);
      if (!raw) { return; }
      var rec = null;
      try { rec = JSON.parse(raw); } catch (pe) {}
      if (!rec || !rec.orderId) {
        localStorage.removeItem(NL_DRAFT_KEY);
        primeAutosave();
        return;
      }
      if (rec.ts && (Date.now() - rec.ts) > NL_DRAFT_TTL_MS) {
        localStorage.removeItem(NL_DRAFT_KEY);
        primeAutosave();
        return;
      }
      fetch(API + '?order_no=' + encodeURIComponent(rec.orderId))
        .then(function (r) { return r.status === 200 ? r.json() : null; })
        .catch(function () { return null; })
        .then(function (row) {
          if (!row || row.error) {
            // Row gone server-side — drop the pointer instead of looping a
            // doomed modal on every visit.
            localStorage.removeItem(NL_DRAFT_KEY);
            primeAutosave();
            return;
          }
          var isDup = typeof rec.orderId === 'string' && rec.orderId.indexOf('DUP-') === 0;
          if (row.funnel_status === 'paid' && !isDup) {
            localStorage.removeItem(NL_DRAFT_KEY);
            primeAutosave();
            return;
          }
          var inCart = cartOrderIdPresent.indexOf(rec.orderId) !== -1;
          setTimeout(function () {
            showNlModal({
              title: inCart ? 'This design is in your cart' : 'Resume your previous design?',
              body: inCart
                ? 'Your last name print is already in your cart, safe and sound. Edit it here, or start a brand-new design.'
                : 'We saved your last name print. Pick up where you left off, or start fresh.',
              primaryLabel: inCart ? 'Edit cart design' : 'Resume',
              secondaryLabel: inCart ? 'Start a new design' : 'Start fresh',
              onPrimary: function () {
                track('draft_resumed', { yor_resume_source: inCart ? 'cart' : 'saved_draft' });
                try {
                  var u = new URL(window.location.href);
                  u.searchParams.set('order_id', rec.orderId);
                  history.replaceState(null, '', u.toString());
                } catch (e) {}
                hydrateFromOrder(rec.orderId)
                  .catch(function () {})
                  .then(primeAutosave);
              },
              onSecondary: function () {
                track('draft_started_fresh', { yor_previous_draft_in_cart: inCart ? 'yes' : 'no' });
                localStorage.removeItem(NL_DRAFT_KEY);
                primeAutosave();
              },
              onDismiss: function () {
                track('draft_resume_dismissed');
                primeAutosave();
              }
            });
          }, 800);
        });
    } catch (e) {
      primeAutosave();
    }
  }

  // --- save for later -----------------------------------------------------
  function buildThumbnailDataUrl(done) {
    buildLayoutThumbnailDataUrl(done);
  }

  function openSaveLaterModal() {
    if (!state.name) { focusNameInput(); return; }
    track('save_for_later_opened');
    var opener = document.activeElement;
    var overlay = document.createElement('div');
    overlay.id = 'nl-save-modal';
    overlay.innerHTML =
      '<style>' +
      '#nl-save-modal{position:fixed;inset:0;z-index:2147483646;display:flex;align-items:center;justify-content:center;background:rgba(20,18,16,0.55);backdrop-filter:blur(4px);font-family:inherit}' +
      '#nl-save-modal .nlsm-card{background:#f5efe6;color:#1c1a17;border-radius:14px;padding:26px;width:min(380px,88vw);text-align:center;box-shadow:0 18px 60px rgba(0,0,0,0.35)}' +
      '#nl-save-modal h3{margin:0 0 6px;font-size:18px;font-weight:600}' +
      '#nl-save-modal p{margin:0 0 14px;font-size:13px;line-height:1.5;color:#6b6357}' +
      '#nl-save-modal input{width:100%;padding:11px 12px;border:1px solid #d6cdbf;border-radius:10px;font:inherit;font-size:14px;margin-bottom:10px;box-sizing:border-box}' +
      '#nl-save-modal .nlsm-row{display:flex;gap:10px}' +
      '#nl-save-modal button{flex:1;padding:11px 14px;border-radius:10px;border:1px solid #d6cdbf;background:#fff;font:inherit;font-size:14px;cursor:pointer}' +
      '#nl-save-modal button.nlsm-primary{background:#1c1a17;color:#f5efe6;border-color:#1c1a17}' +
      '#nl-save-modal .nlsm-status{font-size:12px;min-height:16px;margin:8px 0 0;color:#6b6357}' +
      '</style>' +
      '<div class="nlsm-card" role="dialog" aria-modal="true" aria-labelledby="nlsm-title" aria-describedby="nlsm-description" tabindex="-1">' +
        '<h3 id="nlsm-title">Save your design</h3>' +
        '<p id="nlsm-description">We’ll email you a link so you can pick up right where you left off.</p>' +
        '<input type="email" aria-label="Email address" placeholder="you@example.com" autocomplete="email">' +
        '<div class="nlsm-row">' +
          '<button type="button" class="nlsm-cancel">Cancel</button>' +
          '<button type="button" class="nlsm-primary">Email my design</button>' +
        '</div>' +
        '<p class="nlsm-status" role="status" aria-live="polite" aria-atomic="true"></p>' +
      '</div>';
    document.body.appendChild(overlay);
    var input = overlay.querySelector('input');
    var status = overlay.querySelector('.nlsm-status');
    var close = activateDialog(overlay, overlay.querySelector('.nlsm-card'), opener, input);
    overlay.querySelector('.nlsm-cancel').addEventListener('click', function () { close(false); });
    overlay.querySelector('.nlsm-primary').addEventListener('click', function () {
      var email = (input.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        status.textContent = 'Please enter a valid email address.';
        return;
      }
      status.textContent = 'Checking…';
      (window.SkylitEmailCheck ? window.SkylitEmailCheck(email) : Promise.resolve({ ok: true })).then(function (chk) {
      if (!chk.ok) { status.textContent = chk.message; return; }
      status.textContent = 'Saving…';
      saveDraft().then(function () {
        buildThumbnailDataUrl(function (thumb) {
          // Invisible bot check (assets/skylit-turnstile.js): null on any failure.
          (window.SkylitTurnstile ? window.SkylitTurnstile.token() : Promise.resolve(null)).then(function (botToken) {
            return fetch(ADMIN_BASE + 'api/send-saved/', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ order: orderId, email: email, product_type: 'name_landsat', thumbnail: thumb || '', turnstile_token: botToken || undefined })
            });
          }).then(function (r) {
            if (r.status === 400) {
              return r.json().then(function (j) { status.textContent = (j && j.message) || 'Please check your email address.'; });
            }
            if (r.ok) {
              status.textContent = 'Sent! Check your inbox.';
              announce('Your saved design link has been sent.');
              track('save_for_later_succeeded');
              writeDraftPointer();
              setTimeout(function () { close(false); }, 1600);
            } else {
              status.textContent = 'Could not send right now — please try again.';
              track('save_for_later_failed', { yor_error_type: 'email_send' });
            }
          }).catch(function () {
            status.textContent = 'Could not send right now — please try again.';
            track('save_for_later_failed', { yor_error_type: 'email_send' });
          });
        });
      }).catch(function () {
        status.textContent = 'Could not save your design — check your connection and try again.';
        track('save_for_later_failed', { yor_error_type: 'design_save' });
      });
      });
    });
  }

  // --- share preview ---------------------------------------------------------
  function sharePreview() {
    var toast = function (msg) {
      var t = document.createElement('div');
      t.textContent = msg;
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      t.style.cssText = 'position:fixed;bottom:90px;left:50%;transform:translateX(-50%);background:#1c1a17;color:#f5efe6;padding:10px 18px;border-radius:999px;font-size:13px;z-index:2147483646;';
      document.body.appendChild(t);
      announce(msg);
      setTimeout(function () { t.remove(); }, 2200);
    };
    if (!state.name) {
      if (el.nameMessage) {
        el.nameMessage.textContent = 'Enter your name before sharing this design.';
        el.nameMessage.hidden = false;
      }
      focusNameInput();
      track('share_blocked', { yor_reason: 'name_missing' });
      return;
    }
    var u = new URL(window.location.origin + window.location.pathname);
    var name = normalizedName(state.name);
    var nameLetters = lettersOnly(name);
    u.searchParams.set('name', name);
    if (state.letterKeys.length === nameLetters.length) {
      u.searchParams.set('letters', state.letterKeys.join(','));
    }
    u.searchParams.set('composition', effectiveComposition());
    if (effectiveLineBreak()) {
      u.searchParams.set('break', String(effectiveLineBreak()));
    }
    if (state.caption.trim()) { u.searchParams.set('caption', state.caption.trim().slice(0, 60)); }
    u.searchParams.set('bg', state.backgroundColor.replace('#', ''));
    u.searchParams.set('annotations', state.annotationMode);
    u.searchParams.set('format', state.format);
    u.searchParams.set('size', state.size);
    u.searchParams.set('frame', isFramed() ? state.frame : 'none');
    u.searchParams.set('gift', state.gift);
    if (state.gift === 'ribbon' || state.gift === 'bundle') {
      u.searchParams.set('ribbon', state.ribbonColor);
    }
    if (state.variantId) { u.searchParams.set('variant', state.variantId); }
    var url = u.toString();
    track('share_started');
    if (navigator.share) {
      navigator.share({ title: name + ' — written from orbit', url: url })
        .then(function () {
          announce('Preview shared.');
          track('share_succeeded', { yor_share_method: 'native' });
        })
        .catch(function () { track('share_cancelled', { yor_share_method: 'native' }); });
    } else if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () {
        toast('Link copied — send it to someone');
        track('share_succeeded', { yor_share_method: 'clipboard' });
      }, function () {
        toast(url);
        track('share_failed', { yor_share_method: 'clipboard' });
      });
    } else {
      window.prompt('Copy this link:', url);
      track('share_fallback_prompt');
    }
  }

  function bindGuidedFlow() {
    var tabs = el.stepNav
      ? Array.prototype.slice.call(el.stepNav.querySelectorAll('.cust-step-tab'))
      : [];
    var panels = [el.designStep, el.finishStep, el.giftStep];
    var stepNames = ['design', 'finish', 'gift'];

    // Claim mode: the customer already paid without a gift-wrap decision on
    // the order, and the claim short-circuit never reaches the cart/line-item
    // logic that would honour one. Drop the Gift step from the guided flow
    // entirely — not just visually — so paintStep/showStep/keyboard
    // Home-End-arrow wraparound all treat this as a 2-step flow and it can
    // never be reached, tabbed to, or selected into.
    if (window.SkylitClaim && window.SkylitClaim.active) {
      if (tabs[2]) { tabs[2].setAttribute('hidden', 'hidden'); tabs[2].style.display = 'none'; }
      if (el.giftStep) { el.giftStep.setAttribute('hidden', 'hidden'); el.giftStep.style.display = 'none'; }
      tabs = tabs.slice(0, 2);
      panels = panels.slice(0, 2);
      stepNames = stepNames.slice(0, 2);
    }

    function scrollGuidedStepIntoView() {
      if (!window.matchMedia || !window.matchMedia('(max-width: 880px)').matches || !el.stepNav) { return; }
      var request = ++_nlStepScrollRequest;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          if (request !== _nlStepScrollRequest) { return; }
          var safeTop = 8;
          if (el.previewPane) {
            var previewStyle = window.getComputedStyle(el.previewPane);
            var previewRect = el.previewPane.getBoundingClientRect();
            var stickyTop = parseFloat(previewStyle.top) || 0;
            var isFollowing = previewStyle.position === 'sticky' && previewRect.top <= stickyTop + 10;
            if (isFollowing) { safeTop = Math.ceil(previewRect.bottom) + 8; }
          }
          var navRect = el.stepNav.getBoundingClientRect();
          var targetY = Math.max(0, (window.scrollY || window.pageYOffset || 0) + navRect.top - safeTop);
          var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.scrollTo({ top: targetY, behavior: reducedMotion ? 'auto' : 'smooth' });
        });
      });
    }

    function paintStep() {
      tabs.forEach(function (tab, index) {
        var selected = index + 1 === activeStep;
        tab.classList.toggle('active', selected);
        tab.setAttribute('aria-selected', String(selected));
        tab.setAttribute('aria-current', selected ? 'step' : 'false');
        tab.tabIndex = selected ? 0 : -1;
      });
      panels.forEach(function (panel, index) {
        if (!panel) { return; }
        var selected = index + 1 === activeStep;
        panel.classList.toggle('active', selected);
        panel.hidden = !selected;
      });
      if (el.stepBack) { el.stepBack.disabled = activeStep === 1; }
      if (el.stepNext) { el.stepNext.hidden = activeStep === panels.length; }
      if (el.stepPosition) { el.stepPosition.textContent = 'Step ' + activeStep + ' of ' + panels.length; }
      updateSectionSummaries();
    }

    function showStep(nextStep, options) {
      options = options || {};
      var previousStep = activeStep;
      activeStep = Math.max(1, Math.min(panels.length, Number(nextStep) || 1));
      paintStep();
      if (options.focusTab && tabs[activeStep - 1]) { tabs[activeStep - 1].focus(); }
      if (options.scroll && activeStep !== previousStep) { scrollGuidedStepIntoView(); }
      if (options.track && activeStep !== previousStep) {
        track('section_opened', {
          yor_section: stepNames[activeStep - 1],
          yor_from_section: stepNames[previousStep - 1],
          yor_navigation: options.navigation || 'tab'
        });
      }
    }

    if (el.stepNav) { el.stepNav.setAttribute('role', 'tablist'); }
    tabs.forEach(function (tab, index) {
      var panel = panels[index];
      tab.id = 'nl-tab-' + stepNames[index];
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', panel ? panel.id : '');
      if (panel) {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
      }
      tab.addEventListener('click', function () {
        showStep(index + 1, { scroll: true, track: true, navigation: 'tab' });
      });
      tab.addEventListener('keydown', function (event) {
        var targetStep = null;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          targetStep = activeStep === tabs.length ? 1 : activeStep + 1;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          targetStep = activeStep === 1 ? tabs.length : activeStep - 1;
        } else if (event.key === 'Home') {
          targetStep = 1;
        } else if (event.key === 'End') {
          targetStep = tabs.length;
        }
        if (targetStep) {
          event.preventDefault();
          showStep(targetStep, { focusTab: true, scroll: true, track: true, navigation: 'keyboard' });
        }
      });
    });
    if (el.stepBack) {
      el.stepBack.addEventListener('click', function () {
        showStep(activeStep - 1, { scroll: true, track: true, navigation: 'back' });
      });
    }
    if (el.stepNext) {
      el.stepNext.addEventListener('click', function () {
        showStep(activeStep + 1, { scroll: true, track: true, navigation: 'next' });
      });
    }
    paintStep();
    if (el.undo) { el.undo.addEventListener('click', undoShuffle); }
    if (el.mobileAdd) { el.mobileAdd.addEventListener('click', addToCart); }

    // Show the mobile purchase dock only while the customiser itself is in
    // view. Hide it when the full purchase block is visible to avoid two CTAs.
    if (el.mobilePurchase) {
      var app = document.getElementById('nl-app');
      var cartBlock = document.querySelector('.nl-cart-block');
      var appVisible = true;
      var cartVisible = false;
      var dockPaintQueued = false;
      var syncDockHeight = function () {
        dockPaintQueued = false;
        if (!app) { return; }
        var visible = el.mobilePurchase.classList.contains('nl-mobile-purchase--visible');
        var height = visible
          ? Math.max(0, window.innerHeight - el.mobilePurchase.getBoundingClientRect().top)
          : 0;
        app.style.setProperty('--nl-mobile-dock-height', height + 'px');
      };
      var queueDockHeightSync = function () {
        if (dockPaintQueued) { return; }
        dockPaintQueued = true;
        window.requestAnimationFrame(syncDockHeight);
      };
      var paintDock = function () {
        el.mobilePurchase.classList.toggle('nl-mobile-purchase--visible',
          window.innerWidth <= 880 && appVisible && !cartVisible);
        queueDockHeightSync();
      };
      if ('IntersectionObserver' in window && app) {
        new IntersectionObserver(function (entries) {
          appVisible = entries[0].isIntersecting;
          paintDock();
        }).observe(app);
        if (cartBlock) {
          new IntersectionObserver(function (entries) {
            cartVisible = entries[0].isIntersecting;
            paintDock();
          }, { threshold: 0.25 }).observe(cartBlock);
        }
      }
      window.addEventListener('resize', paintDock);
      if ('ResizeObserver' in window) {
        new ResizeObserver(queueDockHeightSync).observe(el.mobilePurchase);
      }
      paintDock();
    }
  }

  // --- deep-link prefill (complete visual configuration) ---------------------
  function applyPrefillFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var rawName = params.get('name');
    if (!rawName) { return false; }
    var nameResult = sanitizeNameResult(rawName);
    var clean = nameResult.clean;
    if (!clean) { return false; }
    var wasHydrating = isHydrating;
    isHydrating = true;
    try {
      el.name.value = clean;
      state.name = clean;
      showNameFeedback(nameResult);
      var letters = (params.get('letters') || '').split(',').filter(Boolean);
      // Accept shared letter keys only if they line up with the name.
      var cleanLetters = lettersOnly(clean);
      var valid = letters.length === cleanLetters.length && letters.every(function (k, i) {
        return typeof k === 'string' && k.charAt(0).toUpperCase() === cleanLetters[i] && !!variantByKey(k);
      });
      state.letterKeys = valid ? letters : chooseLetterKeys(cleanLetters);
      var sharedComposition = params.get('composition');
      if (sharedComposition === 'two-row' && nameWords(clean).length >= 2) {
        state.composition = 'two-row';
        var sharedBreak = parseInt(params.get('break') || '', 10);
        state.lineBreakAfter = isValidLineBreak(clean, sharedBreak)
          ? sharedBreak
          : suggestedLineBreak(clean);
      } else {
        state.composition = 'single-row';
        state.lineBreakAfter = null;
      }
      updateCompositionControls();
      var cap = params.get('caption');
      if (cap) {
        state.caption = String(cap).slice(0, 60);
        el.caption.value = state.caption;
      }
      var bg = params.get('bg');
      if (bg && /^[0-9a-f]{6}$/i.test(bg)) {
        var hex = '#' + bg.toLowerCase();
        var match = false;
        Array.prototype.forEach.call(el.swatches.children, function (b) {
          var selected = b.dataset.bg === hex;
          if (selected) { match = true; }
          b.classList.toggle('nl-swatch--active', selected);
          b.setAttribute('aria-checked', selected ? 'true' : 'false');
        });
        if (match) { state.backgroundColor = hex; }
      }

      var sharedFormat = params.get('format');
      if (sharedFormat && variants.some(function (v) { return v.format === sharedFormat; })) {
        selectFormat(sharedFormat);
      }
      var sharedSize = resolveSize(params.get('size'));
      if (sharedSize) { selectSize(sharedSize); }
      var sharedFrame = params.get('frame');
      if (isFramed() && sharedFrame && sharedFrame !== 'none' &&
          variants.some(function (v) { return v.format === state.format && v.frame === sharedFrame; })) {
        selectFrame(sharedFrame);
      }
      var sharedAnnotations = params.get('annotations');
      if (sharedAnnotations === 'full' || sharedAnnotations === 'place' || sharedAnnotations === 'none') {
        setAnnotationMode(sharedAnnotations);
      }
      var sharedRibbon = params.get('ribbon');
      if (sharedRibbon && el.ribbonSwatches) {
        var ribbonButtons = Array.prototype.slice.call(el.ribbonSwatches.querySelectorAll('[data-nl-ribbon-color]'));
        var ribbonMatch = ribbonButtons.some(function (b) { return b.dataset.nlRibbonColor === sharedRibbon; });
        if (ribbonMatch) {
          state.ribbonColor = sharedRibbon;
          ribbonButtons.forEach(function (b) {
            var active = b.dataset.nlRibbonColor === sharedRibbon;
            b.classList.toggle('nl-ribbon-swatch--active', active);
            b.setAttribute('aria-checked', active ? 'true' : 'false');
          });
        }
      }
      var sharedGift = params.get('gift');
      if (sharedGift && Object.prototype.hasOwnProperty.call(GIFT_PRICES, sharedGift)) {
        setGift(sharedGift);
      }
    } finally {
      isHydrating = wasHydrating;
    }
    return true;
  }

  // --- events -------------------------------------------------------------
  function onNameInput() {
    var result = sanitizeNameResult(el.name.value);
    var clean = result.clean;
    if (clean !== el.name.value) { el.name.value = clean; }
    state.name = clean;
    state.lineBreakAfter = state.composition === 'two-row' ? suggestedLineBreak(clean) : null;
    applyNameChange(result);
  }
  // Row inputs: Row 1 is the top line, Row 2 the bottom. Each row gets its
  // own MAX_LETTERS budget and the pair joins into the same flat state.name +
  // lineBreakAfter the rest of the app persists.
  function onRowInput() {
    var r1 = sanitizeNameResult(el.nameRow1.value);
    var r2 = sanitizeNameResult(el.nameRow2.value);
    if (r1.clean !== el.nameRow1.value) { el.nameRow1.value = r1.clean; }
    if (r2.clean !== el.nameRow2.value) { el.nameRow2.value = r2.clean; }
    var top = normalizedName(r1.clean), bottom = normalizedName(r2.clean);
    state.name = top ? (bottom ? top + ' ' + bottom : top) : bottom;
    state.lineBreakAfter = (top && bottom) ? lettersOnly(top).length : null;
    applyNameChange({
      clean: state.name,
      transliterated: r1.transliterated || r2.transliterated,
      removed: r1.removed || r2.removed,
      truncated: r1.truncated || r2.truncated,
      source: r1.source + ' ' + r2.source
    });
  }
  function applyNameChange(result) {
    var clean = state.name;
    updateCompositionControls();
    showNameFeedback(result);
    letterHistory = [];
    state.letterKeys = chooseLetterKeys(effectiveLetters());
    renderPreview();
    syncVariant();
    scheduleSave();
    if (clean && !hasTrackedNameEntry) {
      hasTrackedNameEntry = true;
      track('name_entered');
    }
  }
  function bind() {
    if (el.previewToggle && el.previewPane) {
      var previewMinimized = false;
      var siteHeader = document.querySelector('.shopify-section-header');
      var headerTrackUntil = 0;
      var paintPreviewToggle = function (minimized) {
        el.previewPane.classList.toggle('nl-preview-pane--minimized', minimized);
        el.previewToggle.setAttribute('aria-expanded', minimized ? 'false' : 'true');
        el.previewToggle.setAttribute('aria-label', minimized ? 'Show preview' : 'Minimise preview');
        if (el.previewToggleLabel) { el.previewToggleLabel.textContent = minimized ? 'Show preview' : 'Minimise'; }
      };
      var stickyPaintQueued = false;
      var paintPreviewStickyState = function () {
        stickyPaintQueued = false;
        var mobile = window.innerWidth <= 880;
        var headerBottom = 0;
        if (mobile && siteHeader) {
          headerBottom = Math.max(0, Math.ceil(siteHeader.getBoundingClientRect().bottom));
        }
        el.previewPane.style.setProperty('--nl-sticky-top', headerBottom + 'px');
        var stickyTop = parseFloat(window.getComputedStyle(el.previewPane).top) || 0;
        var stuck = mobile && el.previewPane.getBoundingClientRect().top <= stickyTop + 1;
        el.previewPane.classList.toggle('nl-preview-pane--stuck', stuck);
        if (!stuck && el.previewPane.classList.contains('nl-preview-pane--minimized')) {
          previewMinimized = false;
          paintPreviewToggle(false);
        }
        if (Date.now() < headerTrackUntil) { queuePreviewStickyPaint(false); }
      };
      var queuePreviewStickyPaint = function (trackHeader) {
        if (trackHeader) { headerTrackUntil = Date.now() + 450; }
        if (stickyPaintQueued) { return; }
        stickyPaintQueued = true;
        window.requestAnimationFrame(paintPreviewStickyState);
      };
      paintPreviewToggle(false);
      el.previewToggle.addEventListener('click', function () {
        previewMinimized = !el.previewPane.classList.contains('nl-preview-pane--minimized');
        paintPreviewToggle(previewMinimized);
        track('option_changed', {
          yor_option: 'mobile_preview',
          yor_value: previewMinimized ? 'minimized' : 'expanded'
        });
      });
      window.addEventListener('scroll', function () { queuePreviewStickyPaint(true); }, { passive: true });
      window.addEventListener('resize', function () { queuePreviewStickyPaint(true); });
      if (siteHeader) {
        siteHeader.addEventListener('transitionrun', function () { queuePreviewStickyPaint(true); });
        siteHeader.addEventListener('transitionend', function () { queuePreviewStickyPaint(true); });
      }
      queuePreviewStickyPaint(true);
    }
    el.name.addEventListener('input', onNameInput);
    el.name.addEventListener('blur', function () {
      var trimmed = normalizedName(el.name.value);
      if (trimmed !== el.name.value) {
        el.name.value = trimmed;
        onNameInput();
      }
    });
    if (el.nameRow1 && el.nameRow2) {
      [el.nameRow1, el.nameRow2].forEach(function (input) {
        input.addEventListener('input', onRowInput);
        input.addEventListener('blur', function () {
          var trimmed = normalizedName(input.value);
          if (trimmed !== input.value) {
            input.value = trimmed;
            onRowInput();
          }
        });
      });
    }
    if (el.compositions) {
      Array.prototype.forEach.call(el.compositions.querySelectorAll('[data-composition]'), function (btn) {
        btn.addEventListener('click', function () { setComposition(btn.dataset.composition); });
      });
      bindRadioKeyboard(el.compositions, '[data-composition]');
    }
    el.caption.addEventListener('input', function () {
      state.caption = el.caption.value;
      renderPreview();
      scheduleSave();
    });
    // Annotation mode: full / place / none segmented control.
    if (el.annotation) {
      Array.prototype.forEach.call(el.annotation.querySelectorAll('[data-mode]'), function (btn) {
        btn.addEventListener('click', function () {
          setAnnotationMode(btn.dataset.mode);
          scheduleSave();
        });
      });
      bindRadioKeyboard(el.annotation, '[data-mode]');
    }
    // Caption idea chips.
    renderCaptionChips();
    // Gift picker + ribbon swatches.
    if (el.giftGrid) {
      Array.prototype.forEach.call(el.giftGrid.querySelectorAll('[data-nl-gift]'), function (btn) {
        btn.addEventListener('click', function () { setGift(btn.dataset.nlGift); scheduleSave(); });
      });
      bindRadioKeyboard(el.giftGrid, '[data-nl-gift]');
      var ribbonTrig = document.getElementById('nl-ribbon-tooltip-trigger');
      bindTooltipTrigger(ribbonTrig, ribbonTrig && ribbonTrig.closest('.nl-gift-tile-shell'));
      var wrapTrig = document.getElementById('nl-giftwrap-tooltip-trigger');
      bindTooltipTrigger(wrapTrig, wrapTrig && wrapTrig.closest('.nl-gift-tile-shell'));
      var bundleTrig = document.getElementById('nl-bundle-tooltip-trigger');
      bindTooltipTrigger(bundleTrig, bundleTrig && bundleTrig.closest('.nl-gift-tile-shell'));
    }
    if (el.ribbonSwatches) {
      Array.prototype.forEach.call(el.ribbonSwatches.querySelectorAll('[data-nl-ribbon-color]'), function (sw) {
        sw.addEventListener('click', function () {
          state.ribbonColor = sw.dataset.nlRibbonColor;
          Array.prototype.forEach.call(el.ribbonSwatches.children, function (b) {
            var active = b === sw;
            b.classList.toggle('nl-ribbon-swatch--active', active);
            b.setAttribute('aria-checked', active ? 'true' : 'false');
          });
          applyRibbonColor();
          saveGiftExtras();
          track('option_changed', { yor_option: 'ribbon_color', yor_value: state.ribbonColor });
        });
      });
      bindRadioKeyboard(el.ribbonSwatches, '[data-nl-ribbon-color]');
    }
    nlPaperPicker = window.SkylitGifts
      ? window.SkylitGifts.bindPaperPicker(document.getElementById('nl-gift-paper'), function (id) {
          state.giftPaper = id;
          saveGiftExtras();
          applyGiftOverlays();
        })
      : null;
    // Preselect the paper and ribbon colour picked on the gift wrap page.
    // YOR keeps no SkylitGifts memory of its own: a reopened design's choice
    // comes back from loadGiftExtras / the paired cart line later and wins.
    // Wrapping itself stays off until chosen.
    if (window.SkylitGifts && window.SkylitGifts.recallPaperFor) {
      var nlPagePaper = window.SkylitGifts.recallPaperFor(null, state.size);
      if (nlPagePaper) {
        state.giftPaper = nlPagePaper;
        if (nlPaperPicker) nlPaperPicker.set(nlPagePaper);
      }
      var nlPageRibbon = window.SkylitGifts.recallRibbonFor(null);
      if (nlPageRibbon && RIBBON_COLORS[nlPageRibbon]) {
        state.ribbonColor = nlPageRibbon;
        if (el.ribbonSwatches) Array.prototype.forEach.call(el.ribbonSwatches.children, function (b) {
          var active = b.dataset.nlRibbonColor === nlPageRibbon;
          b.classList.toggle('nl-ribbon-swatch--active', active);
          b.setAttribute('aria-checked', active ? 'true' : 'false');
        });
      }
    }
    if (el.saveLater) { el.saveLater.addEventListener('click', openSaveLaterModal); }
    if (el.share) { el.share.addEventListener('click', sharePreview); }
    bindGuidedFlow();
    // Gift-note edits (snippet-owned DOM) should persist via autosave too —
    // delegated because the snippet boots after us.
    document.addEventListener('input', function (e) {
      if (e.target && e.target.id === 'Gift-note-namelandsat') { scheduleSave(); }
    });
    Array.prototype.forEach.call(el.swatches.querySelectorAll('.nl-swatch'), function (sw) {
      sw.addEventListener('click', function () {
        state.backgroundColor = sw.dataset.bg;
        Array.prototype.forEach.call(el.swatches.children, function (b) {
          var active = b === sw;
          b.classList.toggle('nl-swatch--active', active);
          b.setAttribute('aria-checked', active ? 'true' : 'false');
        });
        renderPreview();
        scheduleSave();
        updateSectionSummaries();
        track('option_changed', { yor_option: 'background', yor_value: sw.getAttribute('aria-label') || sw.dataset.bg });
      });
    });
    bindRadioKeyboard(el.swatches, '.nl-swatch');
    bindRadioKeyboard(el.formats, '.nl-option');
    bindRadioKeyboard(el.frames, '.nl-frame-chip');
    bindRadioKeyboard(el.sizes, '.nl-option');
    el.add.addEventListener('click', addToCart);
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(fitPreviewContent, 150);
    });
    if (el.shuffle) { el.shuffle.addEventListener('click', shuffleVariants); }
    // Rebuild chips when the name changes (onNameInput already calls renderPreview
    // which calls renderShuffleToolbar, so no extra listener needed here).
  }

  // --- rehydrate from saved draft -----------------------------------------
  // When the page loads with ?order_id=<id>, fetch the saved draft state from
  // the admin API and restore the customizer to it. Used for "Edit
  // Personalisations" returns from cart and direct draft-resume links.
  function hydrateFromOrder(existingOrderId) {
    return fetch(API + '?order_no=' + encodeURIComponent(existingOrderId))
      .then(function (r) {
        if (!r.ok) { throw new Error('hydrate fetch ' + r.status); }
        return r.json();
      })
      .then(function (data) {
        if (!data || data.error) { throw new Error('hydrate: no data'); }
        // Don't allow editing a paid order (funnel_status is set by the
        // orders/paid webhook; the name_landsat_maps table will have this once
        // the webhook handler is updated to cover name_landsat orders).
        if (data.funnel_status === 'paid') {
          console.log('[Name Landsat] order is paid; ignoring rehydrate');
          var p = new URLSearchParams(window.location.search);
          p.delete('order_id');
          var qs = p.toString();
          window.location.replace(window.location.pathname + (qs ? '?' + qs : ''));
          return;
        }
        isHydrating = true;
        try {
          orderId = existingOrderId;

          // Name + letter variants (frozen, not re-rolled)
          var name = data.name_text || '';
          if (name) {
            el.name.value = name;
            state.name = name;
            var keys = null;
            try { keys = JSON.parse(data.letter_keys || '[]'); } catch (e) {}
            state.letterKeys = (keys && keys.length) ? keys : chooseLetterKeys(lettersOnly(name));
          }
          state.composition = data.composition === 'two-row' && nameWords(state.name).length >= 2
            ? 'two-row'
            : 'single-row';
          state.lineBreakAfter = state.composition === 'two-row' && isValidLineBreak(state.name, data.line_break_after)
            ? Number(data.line_break_after)
            : (state.composition === 'two-row' ? suggestedLineBreak(state.name) : null);
          updateCompositionControls();
          // Caption
          if (data.caption) {
            el.caption.value = data.caption;
            state.caption = data.caption;
          }
          // Annotation mode (falls back to the legacy boolean for old rows).
          setAnnotationMode(data.annotation_mode ||
            (data.show_coordinates ? 'full' : 'none'));
          // Gift wrap. IMPORTANT ordering: read the extras record BEFORE any
          // setGift() call — setGift persists extras as a side effect and
          // would clobber the stored ribbon colour with the default.
          var extras = loadGiftExtras(existingOrderId);
          if (extras && extras.ribbonColor) {
            state.ribbonColor = extras.ribbonColor;
            if (el.ribbonSwatches) {
              Array.prototype.forEach.call(el.ribbonSwatches.children, function (b) {
                var active = b.dataset.nlRibbonColor === state.ribbonColor;
                b.classList.toggle('nl-ribbon-swatch--active', active);
                b.setAttribute('aria-checked', active ? 'true' : 'false');
              });
            }
          }
          if (extras && extras.giftPaper) {
            state.giftPaper = extras.giftPaper;
            if (nlPaperPicker) nlPaperPicker.set(extras.giftPaper);
          }
          if (data.gift_option && GIFT_IDS[data.gift_option]) {
            setGift(data.gift_option);
          }
          if (extras && extras.gift && (extras.gift === 'none' || GIFT_IDS[extras.gift])) {
            setGift(extras.gift);
          }
          if (data.gift_note) {
            applyGiftNote(data.gift_note, data.gift_card_design, data.gift_card_font, !!data.gift_note_enabled);
          }
          // Background swatch
          if (data.background_color) {
            state.backgroundColor = data.background_color;
            Array.prototype.forEach.call(el.swatches.children, function (b) {
              var active = b.dataset.bg === state.backgroundColor;
              b.classList.toggle('nl-swatch--active', active);
              b.setAttribute('aria-checked', active ? 'true' : 'false');
            });
          }
          // Format / size / frame via the regular select handlers so the UI
          // (active classes, availability gating, frame section visibility,
          // variant resolution) all update consistently. isHydrating guard
          // suppresses the autosave that scheduleSave would otherwise fire.
          if (data.selected_type) { selectFormat(data.selected_type); }
          if (data.size) {
            // Resolve through normalizeSize so legacy/non-canonical saved
            // sizes ("40 x 50", "60x80") still select the right variant and
            // get the correct preview aspect ratio. Falling back to the raw
            // value would leave state.size unmatchable → "Not available".
            var resolvedSize = resolveSize(data.size);
            if (resolvedSize) { selectSize(resolvedSize); }
            else { console.warn('[Name Landsat] saved size has no matching variant: ' + data.size); }
          }
          if (data.selected_frame && data.selected_frame !== 'No Frame') {
            selectFrame(data.selected_frame);
          }
          renderPreview();
          // Edit mode only when the design is actually in the live cart —
          // a resumed draft / save-for-later link is a plain editing session
          // (normal ATC copy), matching the other customizers.
          var inCart = cartOrderIdPresent.indexOf(existingOrderId) !== -1;
          isEditMode = inCart;
          console.log('[Name Landsat] hydrated order_id=' + existingOrderId +
            ', editMode=' + isEditMode);
          if (isEditMode) {
            showEditModeIndicator();
            logOrderEvent('edit_personalisations_opened');
            // Paired gift line carries the note/ribbon the customer chose.
            fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
              hydrateGiftNoteFromPairedAddon(cart.items || []);
            }).catch(function () {});
          }
          syncVariant();
          // Belt-and-braces: setOptionAvailability() (called via syncVariant
          // -> refreshOptionMeta, and via each select* call above) already
          // refuses to re-enable a claim-locked button regardless of stock,
          // which is what actually closes this off. This second call is
          // just defence in depth for the ?claim=<token>&order_id=<id>
          // combination that reaches this hydrate path.
          applyClaimLock();
        } finally {
          isHydrating = false;
        }
      });
  }

  // --- init ---------------------------------------------------------------
  // Default-selection logic: after the pickers set initial format/size/frame,
  // override with the first in-stock variant so customers never land on a
  // "Sold out" state. e.g. if A4 Framed Print is out of stock, snap to A4
  // Print Only (or whatever the next available variant is in catalog order).
  function snapToFirstAvailableVariant() {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.available && !v.ukOnly) {
        state.format = v.format;
        state.size = v.size;
        if (v.frame && v.frame !== 'No Frame') {
          state.frame = v.frame;
        }
        el.preview.style.setProperty('--nl-ar', SIZE_AR[state.size] || 1.414);
        return;
      }
    }
  }

  // Honor a ?variant=<id> URL param (Google Shopping / merchant product-sync
  // deep-links, share links, etc.) by preselecting that variant's
  // format/size/frame. Without this the customizer always boots to the first
  // variant (A4), so a feed link promising the 50x70cm price would land the
  // customer on the A4 price and fail Google's discounted-price verification.
  // Runs only when there's no ?order_id= (edit-mode hydration takes precedence
  // and restores the saved order's options instead).
  function applyVariantFromUrl() {
    var wanted = new URLSearchParams(window.location.search).get('variant');
    if (!wanted) { return; }
    var match = null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(wanted)) { match = variants[i]; break; }
    }
    if (!match) { return; }
    selectFormat(match.format);
    var resolvedSize = resolveSize(match.size) || match.size;
    if (resolvedSize) { selectSize(resolvedSize); }
    if (match.frame && match.frame !== 'No Frame') { selectFrame(match.frame); }
  }

  track('customiser_loaded');
  var customizerBooted = false;
  function bootCustomizer() {
    if (customizerBooted) { return; }
    renderFormats();
    renderFrames();
    renderSizes();
    snapToFirstAvailableVariant();
    var bootParams = new URLSearchParams(window.location.search);
    var urlOrderId = bootParams.get('order_id');
    if (!urlOrderId) {
      applyVariantFromUrl();
    }
    updateFrameSection();
    updateGiftTilesForFormat();
    applyAvailability();
    bind();
    // Default empty state; prefill / hydrate may overwrite below.
    el.name.value = '';
    if (el.nameRow1) { el.nameRow1.value = ''; }
    if (el.nameRow2) { el.nameRow2.value = ''; }
    state.name = '';
    state.composition = 'single-row';
    state.lineBreakAfter = null;
    state.letterKeys = chooseLetterKeys(DEFAULT_NAME);
    updateCompositionControls();
    // ?name= deep link (ads, occasion pages, shared previews) — prefills the
    // design; ?letters= restores the exact tiles a share link captured.
    var prefilled = !urlOrderId && applyPrefillFromUrl();
    if (!urlOrderId && !prefilled && window.SkylitGalleryWall && window.SkylitGalleryWall.active()) {
      var gallerySize = resolveSize(bootParams.get('size'));
      if (gallerySize) { selectSize(gallerySize); }
    }
    renderPreview();
    syncVariant();
    setManifestLoadState('ready');
    customizerBooted = true;
    // Claim mode: apply the paid variant now if the claim lookup resolved
    // before boot finished, otherwise just lock down (fail closed) — the
    // 'skylit:claim-ready' listener will apply the variant + lock again
    // once the lookup does resolve.
    if (pendingClaimVariant) {
      applyClaimVariant(pendingClaimVariant);
      pendingClaimVariant = null;
    } else {
      applyClaimLock();
    }
    track('preview_ready');
    // Cart state loads on every boot: edit-mode detection needs it for
    // ?order_id= hydration AND the resume modal needs it for cart-aware copy.
    loadCartItems().then(function () {
      if (urlOrderId) {
        primeAutosave();
        hydrateFromOrder(urlOrderId).catch(function (err) {
          console.warn('[Name Landsat] rehydrate failed:', err && err.message);
        });
        return;
      }
      var hasPointer = false;
      try { hasPointer = !!localStorage.getItem(NL_DRAFT_KEY); } catch (e) {}
      if (prefilled || !hasPointer) {
        // Deep-link intent (or nothing to resume) — no modal; autosave live.
        primeAutosave();
        return;
      }
      // Pointer exists: hold autosave until the customer answers the modal
      // (its branches all prime), so a stray keystroke can't spawn a stub
      // draft that clobbers the pointer mid-decision.
      maybeShowResumeModal();
    });
  }
  function beginCustomizerLoad(isRetry) {
    setManifestLoadState('loading', isRetry ? 'Retrying satellite imagery…' : 'Loading satellite imagery…');
    loadManifest().then(bootCustomizer).catch(function (error) {
      console.warn('[Name Landsat] manifest load failed:', error && error.message);
      track('preview_failed', { yor_retry: isRetry ? 'yes' : 'no' });
      setManifestLoadState('error', 'We couldn’t load the satellite imagery library. Check your connection and try again.');
      announce('Satellite imagery could not load. Try again.');
    });
  }
  // ============================================
  // HEADLESS BOOT — CF Browser-Rendering cart thumbnail host
  // Mirrors moon-myjs.js's window.SkylitMoon.bootHeadless. Unlike moon/star,
  // YOR has no headless entry point today — window.__NL_HEADLESS (set
  // synchronously before this script loads, same convention as
  // window.__MOON_HEADLESS / starmap-v2.js's window.__STARMAP_HEADLESS) is
  // read once at the very bottom of this IIFE to suppress the normal
  // customiser boot (beginCustomizerLoad(false)) so the host's minimal DOM
  // scaffold (which carries only .nl-preview and its children — no
  // format/size/frame pickers) is never touched by renderFormats() /
  // renderSizes() / bind() etc.
  //
  // Called by app/%5Finternal/name-landsat-preview-host in skylit-admin with
  // a plain object built from a name_landsat_maps row (see
  // app/lib/name-landsat-thumbnail-render.ts's rowToState()). Hydrates ONLY
  // the .nl-preview element — the SAME element renderPreview()/applyFrame()
  // already drive for the live customizer, so this can never drift from what
  // the customer approved. Sets window.__nlPreviewReady = true once the
  // letter-tile images have settled (or after a 12s hard cap).
  //
  // NOTE: this hook is purely additive — window.__NL_HEADLESS is undefined
  // for every real customer, so beginCustomizerLoad(false) below still runs
  // exactly as before and nothing here changes what a customer sees. The
  // cart-thumbnail SOURCE (client-canvas vs. server render) is a separate,
  // later change.
  window.SkylitNameLandsat = window.SkylitNameLandsat || {};

  /** Resolve a saved `size` value (any legacy spelling) to a SIZE_AR key. */
  function nlResolveSizeKey(raw) {
    var want = normalizeSize(raw), match = null;
    Object.keys(SIZE_AR).some(function (k) {
      if (normalizeSize(k) === want) { match = k; return true; }
      return false;
    });
    return match;
  }

  /**
   * Wait for every <img> inside #nl-strip to settle (load or error), capped
   * at 12s so a 404'd letter image can never hang the render. Mirrors
   * moon-myjs.js's waitForFrameImages.
   */
  function waitForNlPreviewImages() {
    var TIMEOUT_MS = 12000;
    var imgs = el.strip ? Array.prototype.slice.call(el.strip.querySelectorAll('img')) : [];
    if (!imgs.length) { return Promise.resolve(); }
    var settled = imgs.map(function (img) {
      if (img.complete) { return Promise.resolve(); }
      return new Promise(function (resolve) {
        img.addEventListener('load', resolve, { once: true });
        img.addEventListener('error', resolve, { once: true });
      });
    });
    var timeout = new Promise(function (resolve) { setTimeout(resolve, TIMEOUT_MS); });
    return Promise.race([Promise.all(settled), timeout]);
  }

  /**
   * @param {Object} hs - subset of a name_landsat_maps row: name_text,
   *   letter_keys (JSON string), caption, background_color, composition,
   *   line_break_after, annotation_mode, show_coordinates, size,
   *   selected_type, selected_frame.
   */
  window.SkylitNameLandsat.bootHeadless = function (hs) {
    window.__nlPreviewError = null;
    hs = hs || {};
    return loadManifest().then(function () {
      state.name = (hs.name_text && String(hs.name_text)) || DEFAULT_NAME;
      var letters = lettersOnly(state.name);
      var savedKeys = [];
      try {
        savedKeys = typeof hs.letter_keys === 'string' ? JSON.parse(hs.letter_keys) : (hs.letter_keys || []);
      } catch (e) { savedKeys = []; }
      // Only trust the saved keys when they match the current name letter-
      // for-letter — same guard renderPreview() itself applies, and the same
      // reason: a stale/mismatched array would draw the wrong letter's image
      // in a tile. chooseLetterKeys() re-derives deterministically from the
      // manifest when they don't line up.
      state.letterKeys = (Array.isArray(savedKeys) && savedKeys.length === letters.length)
        ? savedKeys
        : chooseLetterKeys(letters);
      state.caption = hs.caption || '';
      state.backgroundColor = hs.background_color || state.backgroundColor;
      state.composition = hs.composition === 'two-row' ? 'two-row' : 'single-row';
      state.lineBreakAfter = state.composition === 'two-row'
        ? (isValidLineBreak(state.name, hs.line_break_after) ? Number(hs.line_break_after) : suggestedLineBreak(state.name))
        : null;
      // Same fallback loadOrder() uses for legacy rows with no annotation_mode.
      state.annotationMode = hs.annotation_mode || (hs.show_coordinates ? 'full' : 'none');
      state.format = hs.selected_type || 'Framed Print';
      state.frame = (hs.selected_frame && hs.selected_frame !== 'No Frame')
        ? hs.selected_frame
        : (state.format === 'Framed Print' ? 'Black' : '');
      state.size = nlResolveSizeKey(hs.size) || '30 x 40cm';
      el.preview.style.setProperty('--nl-ar', SIZE_AR[state.size] || 1.414);

      renderPreview();

      return waitForNlPreviewImages();
    }).then(function () {
      window.__nlPreviewReady = true;
    }).catch(function (err) {
      window.__nlPreviewError = String((err && err.message) || err);
      // Fail-open: set ready anyway so the puppeteer worker never hangs;
      // it detects __nlPreviewError and declines to persist.
      window.__nlPreviewReady = true;
    });
  };

  if (el.loadRetry) {
    el.loadRetry.addEventListener('click', function () {
      track('preview_retry');
      beginCustomizerLoad(true);
    });
  }
  if (!window.__NL_HEADLESS) {
    beginCustomizerLoad(false);
  }
})();
